const BuilderData = [
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Ahmed Residency",
     "PROJECT ADDRESS": "Sarkhej",
     "BUILDER NAME": "Ahmed Residency",
     "BUILDER CONTACT PERSON NAME": "Wasimbhai Nagani",
     "MOBILE NO. OF CONTACT PERSON": 9924066671,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Ahmed Residency",
     "PROJECT ADDRESS": "Sarkhej",
     "BUILDER NAME": "Ahmed Residency",
     "BUILDER CONTACT PERSON NAME": "Wasimbhai Nagani",
     "MOBILE NO. OF CONTACT PERSON": 9924066671,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Akira 44",
     "PROJECT ADDRESS": "Juhapura Sarkhej",
     "BUILDER NAME": "Akira 44",
     "BUILDER CONTACT PERSON NAME": "Kadirbhai Nagani",
     "MOBILE NO. OF CONTACT PERSON": 9824040066,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Alok Paradise",
     "PROJECT ADDRESS": "Vastral",
     "BUILDER NAME": "Alok Paradise",
     "BUILDER CONTACT PERSON NAME": "Jitu",
     "MOBILE NO. OF CONTACT PERSON": 9998814626,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Ashray 10",
     "PROJECT ADDRESS": "New Ranip",
     "BUILDER NAME": "Ashray 10",
     "BUILDER CONTACT PERSON NAME": "Jayendrabhai",
     "MOBILE NO. OF CONTACT PERSON": 973785559,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Awadh Elegance",
     "PROJECT ADDRESS": "NORTH BOPAL",
     "BUILDER NAME": "HARSHDEEP BUILDERS",
     "BUILDER CONTACT PERSON NAME": "DILIP PATEL",
     "MOBILE NO. OF CONTACT PERSON": 9825042808,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Dev Parivesh",
     "PROJECT ADDRESS": "Sabarmati",
     "BUILDER NAME": "Dev Parivesh",
     "BUILDER CONTACT PERSON NAME": "Bhaveshbhai Patel",
     "MOBILE NO. OF CONTACT PERSON": 9898181718,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Gala Celestia",
     "PROJECT ADDRESS": "Vaishnodevi",
     "BUILDER NAME": "GALA BUILDER",
     "BUILDER CONTACT PERSON NAME": "Kunal",
     "MOBILE NO. OF CONTACT PERSON": 9825096504,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Om Avenue",
     "PROJECT ADDRESS": "SANAND",
     "BUILDER NAME": "Om Avenue",
     "BUILDER CONTACT PERSON NAME": "Mayur",
     "MOBILE NO. OF CONTACT PERSON": 9924443174,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Rajshree Heights",
     "PROJECT ADDRESS": "ODHAV",
     "BUILDER NAME": "Rajshree Heights",
     "BUILDER CONTACT PERSON NAME": "Jyotiben",
     "MOBILE NO. OF CONTACT PERSON": 9925052030,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Rameshwar - 5",
     "PROJECT ADDRESS": "SSI KATHWADA",
     "BUILDER NAME": "Rameshwar - 5",
     "BUILDER CONTACT PERSON NAME": "Naresh",
     "MOBILE NO. OF CONTACT PERSON": 9375002208,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Rose & Crown 2",
     "PROJECT ADDRESS": "DHOLKA",
     "BUILDER NAME": "Rose & Crown 2",
     "BUILDER CONTACT PERSON NAME": "Dhavalbhai",
     "MOBILE NO. OF CONTACT PERSON": 9727798795,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Royal City",
     "PROJECT ADDRESS": "DHOLKA",
     "BUILDER NAME": "Royal City",
     "BUILDER CONTACT PERSON NAME": "Dhavalbhai",
     "MOBILE NO. OF CONTACT PERSON": 9727798795,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Sampad Woods",
     "PROJECT ADDRESS": "MOTERA",
     "BUILDER NAME": "Sampad Woods",
     "BUILDER CONTACT PERSON NAME": "Vishal",
     "MOBILE NO. OF CONTACT PERSON": 9033280059,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Sharan Circle",
     "PROJECT ADDRESS": "CHANDKHEDA",
     "BUILDER NAME": "Sharan Circle",
     "BUILDER CONTACT PERSON NAME": "Mukeshbhai",
     "MOBILE NO. OF CONTACT PERSON": 9099024650,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Shoolin Heighs",
     "PROJECT ADDRESS": "MANINAGAR",
     "BUILDER NAME": "Shoolin Heighs",
     "BUILDER CONTACT PERSON NAME": "Anand",
     "MOBILE NO. OF CONTACT PERSON": 9727307770,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Shri Hari Blessing",
     "PROJECT ADDRESS": "Vatva",
     "BUILDER NAME": "Shri Hari Blessing",
     "BUILDER CONTACT PERSON NAME": "Jivrajbhai",
     "MOBILE NO. OF CONTACT PERSON": 9825066593,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Sunvilla",
     "PROJECT ADDRESS": "VASTRAL",
     "BUILDER NAME": "Sunvilla",
     "BUILDER CONTACT PERSON NAME": "Sanvuk",
     "MOBILE NO. OF CONTACT PERSON": 9099732899,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Swati Crimsons",
     "PROJECT ADDRESS": "SHILAJ",
     "BUILDER NAME": "SWATI CONSTRUCTION",
     "BUILDER CONTACT PERSON NAME": "Himraj",
     "MOBILE NO. OF CONTACT PERSON": 9409143343,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Swati Crysantha",
     "PROJECT ADDRESS": "SHELA",
     "BUILDER NAME": "SWATI CONSTRUCTION",
     "BUILDER CONTACT PERSON NAME": "Himraj",
     "MOBILE NO. OF CONTACT PERSON": 9409143343,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Western Glory",
     "PROJECT ADDRESS": "GOTA",
     "BUILDER NAME": "Western Glory",
     "BUILDER CONTACT PERSON NAME": "JaydeepSinh Chavda",
     "MOBILE NO. OF CONTACT PERSON": 9825329189,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Western Heights",
     "PROJECT ADDRESS": "GOTA",
     "BUILDER NAME": "Western Heights",
     "BUILDER CONTACT PERSON NAME": "JaydeepSinh Chavda",
     "MOBILE NO. OF CONTACT PERSON": 9825329189,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "Pinncle",
     "PROJECT ADDRESS": "Chandkheda",
     "BUILDER NAME": "Pinncle",
     "BUILDER CONTACT PERSON NAME": "Mitul Patel",
     "MOBILE NO. OF CONTACT PERSON": "NA",
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "AHMEDABAD",
     "PROJECT NAME": "SATYAM SKYLINE 2",
     "PROJECT ADDRESS": "MEMNAGAR",
     "BUILDER NAME": "SATYAM GROUP",
     "BUILDER CONTACT PERSON NAME": "PAYAL PATEL",
     "MOBILE NO. OF CONTACT PERSON": 9909983100,
     "MARKETING OFFICER NAME": "MEHUL KAPADIA",
     "MARKETING OFFICER NO.": 9099931686
    },
    {
     "CITY NAME": "BARODA",
     "PROJECT NAME": "Springfield",
     "PROJECT ADDRESS": "Gayatri Mandir, Waghodia Road",
     "BUILDER NAME": "Blue Developers",
     "BUILDER CONTACT PERSON NAME": "Ramesh D Chitroda",
     "MOBILE NO. OF CONTACT PERSON": 9825033805,
     "MARKETING OFFICER NAME": "Ashish",
     "MARKETING OFFICER NO.": 9099969356
    },
    {
     "CITY NAME": "BARODA",
     "PROJECT NAME": "Mangla Marvel",
     "PROJECT ADDRESS": "Near Uma Vidyalaya, Tarsali",
     "BUILDER NAME": "M K Enterprises",
     "BUILDER CONTACT PERSON NAME": "Jignesh Pathak",
     "MOBILE NO. OF CONTACT PERSON": 9662610058,
     "MARKETING OFFICER NAME": "Surya",
     "MARKETING OFFICER NO.": 8980009855
    },
    {
     "CITY NAME": "BARODA",
     "PROJECT NAME": "24 K\/7 FORTUNE",
     "PROJECT ADDRESS": "Gotri, Baroda",
     "BUILDER NAME": "AXIS INFRATECH PVT LTD",
     "BUILDER CONTACT PERSON NAME": "Dhaval Shah",
     "MOBILE NO. OF CONTACT PERSON": 9624024680,
     "MARKETING OFFICER NAME": "Ashish",
     "MARKETING OFFICER NO.": 9099969356
    },
    {
     "CITY NAME": "BARODA",
     "PROJECT NAME": "Florence Exotica III",
     "PROJECT ADDRESS": "Alkapuri, Baroda",
     "BUILDER NAME": "I Dream infra",
     "BUILDER CONTACT PERSON NAME": "Mihir Danak",
     "MOBILE NO. OF CONTACT PERSON": 9824023078,
     "MARKETING OFFICER NAME": "Surya",
     "MARKETING OFFICER NO.": 8980009855
    },
    {
     "CITY NAME": "BARODA",
     "PROJECT NAME": "Kuber Expression",
     "PROJECT ADDRESS": "Dabhoi Road, Baroda",
     "BUILDER NAME": "Kuber Expression",
     "BUILDER CONTACT PERSON NAME": "Virang R Shah",
     "MOBILE NO. OF CONTACT PERSON": 9227222883,
     "MARKETING OFFICER NAME": "Sanket",
     "MARKETING OFFICER NO.": 9909339017
    },
    {
     "CITY NAME": "BARODA",
     "PROJECT NAME": "Tithi heights",
     "PROJECT ADDRESS": "New Alkapuri, Gotri",
     "BUILDER NAME": "Gayatri Developer",
     "BUILDER CONTACT PERSON NAME": "Manoj Patel",
     "MOBILE NO. OF CONTACT PERSON": 9099533322,
     "MARKETING OFFICER NAME": "Sanket",
     "MARKETING OFFICER NO.": 9909339017
    },
    {
     "CITY NAME": "BARODA",
     "PROJECT NAME": "Pushp Villa",
     "PROJECT ADDRESS": "New Alkapuri, Gotri",
     "BUILDER NAME": "Taksh Infra",
     "BUILDER CONTACT PERSON NAME": "Neeraj B Desai",
     "MOBILE NO. OF CONTACT PERSON": 9925230931,
     "MARKETING OFFICER NAME": "Harmeet",
     "MARKETING OFFICER NO.": 9988008360
    },
    {
     "CITY NAME": "BARODA",
     "PROJECT NAME": "Shree One",
     "PROJECT ADDRESS": "Bhayli, Baroda",
     "BUILDER NAME": "Shreejiinfrastructure",
     "BUILDER CONTACT PERSON NAME": "Mayank Ruparelia",
     "MOBILE NO. OF CONTACT PERSON": 9033003914,
     "MARKETING OFFICER NAME": "Harmeet",
     "MARKETING OFFICER NO.": 9988008360
    },
    {
     "CITY NAME": "BARODA",
     "PROJECT NAME": "Shivdarshan Duplex",
     "PROJECT ADDRESS": "Near L&T Knowledge Park, Village Ankhol",
     "BUILDER NAME": "M\/S NANDI DEVELOPERS",
     "BUILDER CONTACT PERSON NAME": "BHARATBHAI HIRAPARA",
     "MOBILE NO. OF CONTACT PERSON": 9099981999,
     "MARKETING OFFICER NAME": "Ashish",
     "MARKETING OFFICER NO.": 9099969356
    },
    {
     "CITY NAME": "BARODA",
     "PROJECT NAME": "Rajvir Aries",
     "PROJECT ADDRESS": "Sevasi, Baroda",
     "BUILDER NAME": "RAJVIR ARIES INFRATECH",
     "BUILDER CONTACT PERSON NAME": "Mitul Patel",
     "MOBILE NO. OF CONTACT PERSON": 9898783221,
     "MARKETING OFFICER NAME": "Surya",
     "MARKETING OFFICER NO.": 8980009855
    },
    {
     "CITY NAME": "BARODA",
     "PROJECT NAME": "Tirth Villas",
     "PROJECT ADDRESS": "NEAR NILAMBER SERENE, CANAL ROAD BHAYALI, MOJE BHAYALI VADODARA",
     "BUILDER NAME": "M\/S SILVER LINE DEVELOPERS",
     "BUILDER CONTACT PERSON NAME": "SURESH H SONI",
     "MOBILE NO. OF CONTACT PERSON": 9825062345,
     "MARKETING OFFICER NAME": "Ashish",
     "MARKETING OFFICER NO.": 9099969356
    },
    {
     "CITY NAME": "RAJKOT",
     "PROJECT NAME": "AURUM ONE",
     "PROJECT ADDRESS": "VARDHMAN NAGAR 2ND RING ROAD",
     "BUILDER NAME": "KASTURI ENTERPRISE",
     "BUILDER CONTACT PERSON NAME": "ASHISH MEHTA",
     "MOBILE NO. OF CONTACT PERSON": 9909700200,
     "MARKETING OFFICER NAME": "SURAJ R BHASIN",
     "MARKETING OFFICER NO.": 9687603047
    },
    {
     "CITY NAME": "BHAVNAGAR",
     "PROJECT NAME": "VAMA ELEGANCE",
     "PROJECT ADDRESS": "Takheteshwar Temple,Near Doctor Maltiben Hospital,Bhavnagar,Gujarat 364001",
     "BUILDER NAME": "SHIVAM AMRUT DEVELOPERS",
     "BUILDER CONTACT PERSON NAME": "Mr.DEEPAKBHAI",
     "MOBILE NO. OF CONTACT PERSON": "98252-07468",
     "MARKETING OFFICER NAME": "CHAUDHARY RAM PRAKASH DORIA",
     "MARKETING OFFICER NO.": 6393876225
    },
    {
     "CITY NAME": "BHAVNAGAR",
     "PROJECT NAME": "THE IMPERIAL HEIGHT",
     "PROJECT ADDRESS": "KailashDham Society,B.A.D.A.VikashpathBhavnagar,G u jarat-364002",
     "BUILDER NAME": "Shree Ram Infrastructure",
     "BUILDER CONTACT PERSON NAME": "Mr.KALPESHBHAI",
     "MOBILE NO. OF CONTACT PERSON": "98248-80041",
     "MARKETING OFFICER NAME": "CHAUDHARY RAM PRAKASH DORIA",
     "MARKETING OFFICER NO.": 6393876225
    },
    {
     "CITY NAME": "SURAT",
     "PROJECT NAME": "Veerbhadra Hieghts",
     "PROJECT ADDRESS": "Near Audi Showroom, B\/h Vastub Laxuria, Rundh, Sub Dist. Majura, Dist. Surat -395007.",
     "BUILDER NAME": "M\/s. AVANTIKA DEVELOPERS",
     "BUILDER CONTACT PERSON NAME": "Mr. Amar Shah",
     "MOBILE NO. OF CONTACT PERSON": 9898333453,
     "MARKETING OFFICER NAME": "Brinda Chadhari",
     "MARKETING OFFICER NO.": 9427168129
    },
    {
     "CITY NAME": "SURAT",
     "PROJECT NAME": "Rivera The Atlantis",
     "PROJECT ADDRESS": "Shyam Dham Mandir Road, Sarthana Jagat Naka, Valak Patia, Kamrej Surat\n- 395006",
     "BUILDER NAME": "M\/s. Mark Developers",
     "BUILDER CONTACT PERSON NAME": "Mr. Alpesh",
     "MOBILE NO. OF CONTACT PERSON": 9909406125,
     "MARKETING OFFICER NAME": "Brinda Chadhari",
     "MARKETING OFFICER NO.": 9427168130
    },
    {
     "CITY NAME": "SURAT",
     "PROJECT NAME": "Shreepad Seasons",
     "PROJECT ADDRESS": "At Palanpur-Gauravpath Road,Adajan, Surat-395009",
     "BUILDER NAME": "M\/S. Shubh Corporation",
     "BUILDER CONTACT PERSON NAME": "Mr. Chirag Vaghasiya",
     "MOBILE NO. OF CONTACT PERSON": 9099293777,
     "MARKETING OFFICER NAME": "Brinda Chadhari",
     "MARKETING OFFICER NO.": 9427168131
    },
    {
     "CITY NAME": "BHOPAL",
     "PROJECT NAME": "Chhitrakoot Phase II",
     "PROJECT ADDRESS": "GRAM RASLAKHEDI KAROND BYPASS ROAD NEAR MITTAL COLLEGE BHOPAL",
     "BUILDER NAME": "MR. KL SHARMA AND MR. NEERAJ SHARMA",
     "BUILDER CONTACT PERSON NAME": "Mr. Mukesh Mishra",
     "MOBILE NO. OF CONTACT PERSON": 9993771030,
     "MARKETING OFFICER NAME": "SUBODH",
     "MARKETING OFFICER NO.": 7389949928
    },
    {
     "CITY NAME": "GWALIOR",
     "PROJECT NAME": "SUN VELLEY",
     "PROJECT ADDRESS": "VILLAGE DONGAPUR PUTLIGHAR CITY CENTRE EXTENSION GWALIOR",
     "BUILDER NAME": "SUN LIFE INFRATECH",
     "BUILDER CONTACT PERSON NAME": "YOGESH KHANDELWAL",
     "MOBILE NO. OF CONTACT PERSON": 9425117256,
     "MARKETING OFFICER NAME": "HITESH KUMAR",
     "MARKETING OFFICER NO.": 9873508570
    },
    {
     "CITY NAME": "INDORE",
     "PROJECT NAME": "DCNPL Hills Vista",
     "PROJECT ADDRESS": "55 ASHOKA HERITAGE, 3RD FLOOR, PRINCE YASHWANT ROAD,INDORE",
     "BUILDER NAME": "DCNPL PRIVATE LIMITED",
     "BUILDER CONTACT PERSON NAME": "Mr SANJAY JAIN",
     "MOBILE NO. OF CONTACT PERSON": 9893127299,
     "MARKETING OFFICER NAME": "M P Singh",
     "MARKETING OFFICER NO.": 8887674777
    },
    {
     "CITY NAME": "INDORE",
     "PROJECT NAME": "ATLANTA AURA",
     "PROJECT ADDRESS": "SARVEY NO. 288\/4, PIPLIYAKUMAR, OPP. APOLLO D. B. CITY, INDORE",
     "BUILDER NAME": "ATLANTA AURA",
     "BUILDER CONTACT PERSON NAME": "Mr PITAMBAR WADHWANI",
     "MOBILE NO. OF CONTACT PERSON": 9926390000,
     "MARKETING OFFICER NAME": "M P Singh",
     "MARKETING OFFICER NO.": 8887674778
    },
    {
     "CITY NAME": "INDORE",
     "PROJECT NAME": "M\/S Ghanshyam Castle",
     "PROJECT ADDRESS": "Khajrana, Indore",
     "BUILDER NAME": "M\/S JRK Developers",
     "BUILDER CONTACT PERSON NAME": "Mr Vallabh ji",
     "MOBILE NO. OF CONTACT PERSON": 8818880724,
     "MARKETING OFFICER NAME": "M P Singh",
     "MARKETING OFFICER NO.": 8887674779
    },
    {
     "CITY NAME": "INDORE",
     "PROJECT NAME": "M\/S Shivneri Sahil  Empire",
     "PROJECT ADDRESS": "Near Agrawal Public School, Indore",
     "BUILDER NAME": "M\/S J K Buildcon",
     "BUILDER CONTACT PERSON NAME": "Mr Kandhari ji",
     "MOBILE NO. OF CONTACT PERSON": 9893070007,
     "MARKETING OFFICER NAME": "M P Singh",
     "MARKETING OFFICER NO.": 8887674780
    },
    {
     "CITY NAME": "INDORE",
     "PROJECT NAME": "Kalptaru Grandeur",
     "PROJECT ADDRESS": "Plot no 27 Yashwant Niwas Road, Indore",
     "BUILDER NAME": "M\/S Sai Charan properties Ltd",
     "BUILDER CONTACT PERSON NAME": "Mr Pritesh",
     "MOBILE NO. OF CONTACT PERSON": 9425904443,
     "MARKETING OFFICER NAME": "M P Singh",
     "MARKETING OFFICER NO.": 8887674781
    },
    {
     "CITY NAME": "INDORE",
     "PROJECT NAME": "Palazzo Park Residences",
     "PROJECT ADDRESS": "Pipliya kumar, Nipaniya, Indore",
     "BUILDER NAME": "M\/S Shivam Constructions",
     "BUILDER CONTACT PERSON NAME": "Mr Devendra Kumawat",
     "MOBILE NO. OF CONTACT PERSON": 9425056662,
     "MARKETING OFFICER NAME": "M P Singh",
     "MARKETING OFFICER NO.": 8887674782
    },
    {
     "CITY NAME": "INDORE",
     "PROJECT NAME": "Rainbow Residency",
     "PROJECT ADDRESS": "Snehlataganj, Indore",
     "BUILDER NAME": "Madhya pradesh housing board",
     "BUILDER CONTACT PERSON NAME": "Rajesh Gupta",
     "MOBILE NO. OF CONTACT PERSON": 9406912054,
     "MARKETING OFFICER NAME": "M P Singh",
     "MARKETING OFFICER NO.": 8887674783
    },
    {
     "CITY NAME": "INDORE",
     "PROJECT NAME": "Cliffton Park",
     "PROJECT ADDRESS": "Near Brilliant Convention Centre,  Kabirkhedi, Indore",
     "BUILDER NAME": "VERTICAL Homes LLP",
     "BUILDER CONTACT PERSON NAME": "Mr Garimesh Goyal",
     "MOBILE NO. OF CONTACT PERSON": 9589533998,
     "MARKETING OFFICER NAME": "M P Singh",
     "MARKETING OFFICER NO.": 8887674784
    },
    {
     "CITY NAME": "INDORE",
     "PROJECT NAME": "Sky Meridian",
     "PROJECT ADDRESS": "Village Harniyakhedi, Mhow, Indore",
     "BUILDER NAME": "M\/S Prosperity Residency pvt ltd",
     "BUILDER CONTACT PERSON NAME": "Mr Paras Doshi",
     "MOBILE NO. OF CONTACT PERSON": 9826030906,
     "MARKETING OFFICER NAME": "M P Singh",
     "MARKETING OFFICER NO.": 8887674785
    },
    {
     "CITY NAME": "INDORE",
     "PROJECT NAME": "D B Pride",
     "PROJECT ADDRESS": "Talawali Chanda, Patwari halka no 17, Indore",
     "BUILDER NAME": "M\/S D B\nInfrastructure pvt ltd",
     "BUILDER CONTACT PERSON NAME": "Ms Shweta Sharma",
     "MOBILE NO. OF CONTACT PERSON": 8889477756,
     "MARKETING OFFICER NAME": "M P Singh",
     "MARKETING OFFICER NO.": 8887674786
    },
    {
     "CITY NAME": "INDORE",
     "PROJECT NAME": "Avasa Avenue",
     "PROJECT ADDRESS": "Village Bijalpur, A B road, Indore",
     "BUILDER NAME": "Shri Shristi construction pvt ltd",
     "BUILDER CONTACT PERSON NAME": "Mr Vinit ji",
     "MOBILE NO. OF CONTACT PERSON": 8889995838,
     "MARKETING OFFICER NAME": "M P Singh",
     "MARKETING OFFICER NO.": 8887674787
    },
    {
     "CITY NAME": "JABALPUR",
     "PROJECT NAME": "KRISHNA PARISAR PHASE 2",
     "PROJECT ADDRESS": "INFRONT OF PANCHMUKHI HANUMAN MANDIR SHAHI NAKA SNAJEEVNI NAGAR MAIN ROAD GARHA JABALPUR 482001 MP",
     "BUILDER NAME": "ROHIT TIWARI",
     "BUILDER CONTACT PERSON NAME": "ADITYA SHARMA",
     "MOBILE NO. OF CONTACT PERSON": 8962767875,
     "MARKETING OFFICER NAME": "ASHISH SHIVHARE",
     "MARKETING OFFICER NO.": 9165592999
    },
    {
     "CITY NAME": "JABALPUR",
     "PROJECT NAME": "KRISHNA PARISAR PHASE 1",
     "PROJECT ADDRESS": "INFRONT OF PANCHMUKHI HANUMAN MANDIR SHAHI NAKA SNAJEEVNI NAGAR MAIN ROAD GARHA JABALPUR 482001 MP",
     "BUILDER NAME": "AJAY DUBEY",
     "BUILDER CONTACT PERSON NAME": "SURESH SAHNI",
     "MOBILE NO. OF CONTACT PERSON": 8839046039,
     "MARKETING OFFICER NAME": "ASHISH SHIVHARE",
     "MARKETING OFFICER NO.": 9165592999
    },
    {
     "CITY NAME": "JABALPUR",
     "PROJECT NAME": "OJAS IMPERIA",
     "PROJECT ADDRESS": "BANDARIYA TIRAHA, KATANGA JABALPUR MP 482001",
     "BUILDER NAME": "SK PARWANI",
     "BUILDER CONTACT PERSON NAME": "MR NAIDU",
     "MOBILE NO. OF CONTACT PERSON": 9179104762,
     "MARKETING OFFICER NAME": "SATISH SAHU",
     "MARKETING OFFICER NO.": 8454020408
    },
    {
     "CITY NAME": "BHILAI",
     "PROJECT NAME": "SHUBHKAMNA HEIGHTS",
     "PROJECT ADDRESS": "SHUBHKAMNA HEIGHTS, PRAGATI NAGAR RISALI BHILAI, DIST- DURG C.G. 490006",
     "BUILDER NAME": "SHUBH LABH ASSOCIATES",
     "BUILDER CONTACT PERSON NAME": "MR DINESH VAJPAI",
     "MOBILE NO. OF CONTACT PERSON": 9827104187,
     "MARKETING OFFICER NAME": "BALRAM GERA, MANISHA TIRKEY",
     "MARKETING OFFICER NO.": "8889433396,\n8889500354"
    },
    {
     "CITY NAME": "RAIPUR",
     "PROJECT NAME": "Avinash New County",
     "PROJECT ADDRESS": "Sector,30 Atal nagar Raipur",
     "BUILDER NAME": "Avinash Developers Pvt. Ltd.",
     "BUILDER CONTACT PERSON NAME": "Manas Agrawal",
     "MOBILE NO. OF CONTACT PERSON": 7415113959,
     "MARKETING OFFICER NAME": "Ajay Vyas",
     "MARKETING OFFICER NO.": 9685000393
    },
    {
     "CITY NAME": "RAIPUR",
     "PROJECT NAME": "Godariwala City",
     "PROJECT ADDRESS": "Ring Road No 1, Pachpedi Naka, Raipur",
     "BUILDER NAME": "M M Realestate",
     "BUILDER CONTACT PERSON NAME": "Vivek Kukreja",
     "MOBILE NO. OF CONTACT PERSON": 9882507753,
     "MARKETING OFFICER NAME": "Arnika Minz",
     "MARKETING OFFICER NO.": 7771968330
    },
    {
     "CITY NAME": "RAIPUR",
     "PROJECT NAME": "GarimaApartment",
     "PROJECT ADDRESS": "Priydarshani Nagar",
     "BUILDER NAME": "M\/S Shrivastava Associate",
     "BUILDER CONTACT PERSON NAME": "Rajesh Shrivastava\n& Veena Shrivasatava",
     "MOBILE NO. OF CONTACT PERSON": 9827102364,
     "MARKETING OFFICER NAME": "Ritika Kumari",
     "MARKETING OFFICER NO.": 6263148624
    },
    {
     "CITY NAME": "RAIPUR",
     "PROJECT NAME": "Samta Parisar",
     "PROJECT ADDRESS": "Pachpedi Naka",
     "BUILDER NAME": "M\/S Samta Parisar",
     "BUILDER CONTACT PERSON NAME": "Mr. Lalit Kumar",
     "MOBILE NO. OF CONTACT PERSON": 9425240398,
     "MARKETING OFFICER NAME": "Tarun Rai",
     "MARKETING OFFICER NO.": 9415671881
    },
    {
     "CITY NAME": "RAIPUR",
     "PROJECT NAME": "‘Kingstown’",
     "PROJECT ADDRESS": "Navbharat udhyog Bhawan beside Airtel office ring rd. no 1 Telebandha",
     "BUILDER NAME": "M\/S Navbharat dwelling pvt. Ltd.",
     "BUILDER CONTACT PERSON NAME": "Roshan",
     "MOBILE NO. OF CONTACT PERSON": 8370007204,
     "MARKETING OFFICER NAME": "Arnika Minz",
     "MARKETING OFFICER NO.": 7771968330
    },
    {
     "CITY NAME": "RAIPUR",
     "PROJECT NAME": "Swarnabhoomi phase 1",
     "PROJECT ADDRESS": "Near MGM Eye Hospital, Vidhan Sabha Road",
     "BUILDER NAME": "m\/s Fortune Resources Pvt. Ltd.",
     "BUILDER CONTACT PERSON NAME": "Nissar Ahmad",
     "MOBILE NO. OF CONTACT PERSON": 7566110001,
     "MARKETING OFFICER NAME": "Ajay Vyas",
     "MARKETING OFFICER NO.": 9685000393
    },
    {
     "CITY NAME": "BELGAUM",
     "PROJECT NAME": "ZENITH & PINNACLE",
     "PROJECT ADDRESS": "LOTUS COUNTY,LOTUS LANDMARK INDIA PVT.LTD,OPP AIR FORCE GROUND,M G ROAD,BELGAUM-590006",
     "BUILDER NAME": "LOTUS LANDMARK INDIA PVT.LTD",
     "BUILDER CONTACT PERSON NAME": "SATISH WAMAN GIRI",
     "MOBILE NO. OF CONTACT PERSON": 9890520207,
     "MARKETING OFFICER NAME": "satish",
     "MARKETING OFFICER NO.": 9359528817
    },
    {
     "CITY NAME": "BELGAUM",
     "PROJECT NAME": "SAIRAJ EMPIRE",
     "PROJECT ADDRESS": "R S NO.1367,1368,CTS NO.328,ROY ROAD,TILAKWADI,BELGAUM",
     "BUILDER NAME": "SAIRAJ BUILDER",
     "BUILDER CONTACT PERSON NAME": "MAHESH NARAYAN FAGARE",
     "MOBILE NO. OF CONTACT PERSON": "0831-4210576",
     "MARKETING OFFICER NAME": "ashwini",
     "MARKETING OFFICER NO.": 9980546181
    },
    {
     "CITY NAME": "BELGAUM",
     "PROJECT NAME": "OMKARA",
     "PROJECT ADDRESS": "CTS NO.1114,1115\/1,1115\/2,BICHU GALLI,SHAHAPUR,BELGAUM",
     "BUILDER NAME": "HORIZON GROUP",
     "BUILDER CONTACT PERSON NAME": "RAJESH P JADHAV",
     "MOBILE NO. OF CONTACT PERSON": "0831-2486969",
     "MARKETING OFFICER NAME": "sibshis",
     "MARKETING OFFICER NO.": 9535674260
    },
    {
     "CITY NAME": "BELGAUM",
     "PROJECT NAME": "PINK ORCHID",
     "PROJECT ADDRESS": "R S NO.186\/1+2\/2A,CTS NO.2322\/1,II STAGE HANUMAN NAGAR,KANGRALI KHURD,BELGAUM-590010",
     "BUILDER NAME": "EKDANT DEVELOPERS",
     "BUILDER CONTACT PERSON NAME": "BASAVARAJ S KAJAGAR",
     "MOBILE NO. OF CONTACT PERSON": 9880213050,
     "MARKETING OFFICER NAME": "vigneshwan s",
     "MARKETING OFFICER NO.": 9894675139
    },
    {
     "CITY NAME": "BELGAUM",
     "PROJECT NAME": "VIPRA VAIBHAVA",
     "PROJECT ADDRESS": "CTS NO.2863,2864 AT BHAGYANAGAR,ANGOL,BELGAUM",
     "BUILDER NAME": "CHAITANYA ASSOCIATES",
     "BUILDER CONTACT PERSON NAME": "CHAITANYA KULKARNI",
     "MOBILE NO. OF CONTACT PERSON": "0831-4201182",
     "MARKETING OFFICER NAME": "satish",
     "MARKETING OFFICER NO.": 9359528817
    },
    {
     "CITY NAME": "BELGAUM",
     "PROJECT NAME": "UR CASA",
     "PROJECT ADDRESS": "R S NO.46\/A\/1A,AMBEDKAR NAGAR,KANGRALI KH,BELGAUM",
     "BUILDER NAME": "VISHWARAJ DEVELOPERS",
     "BUILDER CONTACT PERSON NAME": "RAJU K PASANNAVAR",
     "MOBILE NO. OF CONTACT PERSON": "0831-2472007",
     "MARKETING OFFICER NAME": "vigneswasran s",
     "MARKETING OFFICER NO.": 9894675139
    },
    {
     "CITY NAME": "BELGAUM",
     "PROJECT NAME": "SAIRAJ PHASE 1",
     "PROJECT ADDRESS": "CTS NO.371\/A,371\/B 371\/C,371\/D NEHARU ROAD TILAKWADI",
     "BUILDER NAME": "SAIRAJ BUILDERS AND DEVELOPERS",
     "BUILDER CONTACT PERSON NAME": "MAHESH NARAYAN FAGARE",
     "MOBILE NO. OF CONTACT PERSON": "0831-4210576",
     "MARKETING OFFICER NAME": "Aswini",
     "MARKETING OFFICER NO.": 9980546181
    },
    {
     "CITY NAME": "HYDERABAD",
     "PROJECT NAME": "KALPATARU RESIDENCY",
     "PROJECT ADDRESS": "KALPATARU RESIDENCY, ERRAGADDA, HYD",
     "BUILDER NAME": "KALPATARU",
     "BUILDER CONTACT PERSON NAME": "MR. SURAJ KIRAN",
     "MOBILE NO. OF CONTACT PERSON": 9515664840,
     "MARKETING OFFICER NAME": "MR. DEEPAK KUMAR",
     "MARKETING OFFICER NO.": 9031919614
    },
    {
     "CITY NAME": "HYDERABAD",
     "PROJECT NAME": "LOKNATH ENCLAVE",
     "PROJECT ADDRESS": "LOKNATH ENCLAVE, KAPRA, MEDCHAL MALKAJGIRI, HYD",
     "BUILDER NAME": "DANDE CONSTRUCTIONS",
     "BUILDER CONTACT PERSON NAME": "VEDALA RAMBABU",
     "MOBILE NO. OF CONTACT PERSON": 9866125272,
     "MARKETING OFFICER NAME": "MR. B RAVI KUMAR",
     "MARKETING OFFICER NO.": 9885077357
    },
    {
     "CITY NAME": "HYDERABAD",
     "PROJECT NAME": "KENWORTH",
     "PROJECT ADDRESS": "PROVIDENT KENWORTH, PVNR EXPRESSWAY, SHIVRAMPALLY, RAJENDRANAGAR, HYD",
     "BUILDER NAME": "PROVIDENT",
     "BUILDER CONTACT PERSON NAME": "MR. Y GOPI KRISHNA",
     "MOBILE NO. OF CONTACT PERSON": 9652050044,
     "MARKETING OFFICER NAME": "MR. DEEPAK KUMAR",
     "MARKETING OFFICER NO.": 9031919614
    },
    {
     "CITY NAME": "HYDERABAD",
     "PROJECT NAME": "SARK AK HEIGHTS TWO",
     "PROJECT ADDRESS": "Sark Heights Two in survey no.167\/P , Kondapur Village, Serilingampally, Hyderabad",
     "BUILDER NAME": "Madhusudhan Rao",
     "BUILDER CONTACT PERSON NAME": "Madhusudhan Rao",
     "MOBILE NO. OF CONTACT PERSON": 9866312456,
     "MARKETING OFFICER NAME": "Madhusudhan Rao",
     "MARKETING OFFICER NO.": 9866312456
    },
    {
     "CITY NAME": "MANGALORE",
     "PROJECT NAME": "SHANTHALA LAVA - KUSHA",
     "PROJECT ADDRESS": "VYASANAGAR, DERABAIL, MANGALORE",
     "BUILDER NAME": "M\/S.GUARDIAN INFRASTRUCTURE BUILDER AND DEVELOPERS",
     "BUILDER CONTACT PERSON NAME": "MR.GANESH M P",
     "MOBILE NO. OF CONTACT PERSON": 9880137911,
     "MARKETING OFFICER NAME": "PRASAD KUMAR NAYAK",
     "MARKETING OFFICER NO.": 9739441348
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Park Square Avenue",
     "PROJECT ADDRESS": "HSR LAYOUT",
     "BUILDER NAME": "M\/s Park Square Infratech",
     "BUILDER CONTACT PERSON NAME": "Sales Person",
     "MOBILE NO. OF CONTACT PERSON": 9590439555,
     "MARKETING OFFICER NAME": "Ashok Kumar Lukkani",
     "MARKETING OFFICER NO.": 8903561645
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Park West",
     "PROJECT ADDRESS": "BASAVESHWAR NAGAR",
     "BUILDER NAME": "M\/s Relationship Properties Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Sales Person",
     "MOBILE NO. OF CONTACT PERSON": 7676171751,
     "MARKETING OFFICER NAME": "Sumit Gaurav",
     "MARKETING OFFICER NO.": 9884995820
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Serenity Lakeview",
     "PROJECT ADDRESS": "SARJAPUR ROAD",
     "BUILDER NAME": "M\/s GCK Builders",
     "BUILDER CONTACT PERSON NAME": "Sales Person",
     "MOBILE NO. OF CONTACT PERSON": 9953405518,
     "MARKETING OFFICER NAME": "Ashok Kumar Lukkani",
     "MARKETING OFFICER NO.": 8903561645
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Klassik Landmark",
     "PROJECT ADDRESS": "BANNERGHATTA ROAD",
     "BUILDER NAME": "M\/s Klassik Enterprises  Pvt. Ltd.",
     "BUILDER CONTACT PERSON NAME": "Sales Person",
     "MOBILE NO. OF CONTACT PERSON": 9004431604,
     "MARKETING OFFICER NAME": "Ashok Kumar Lukkani",
     "MARKETING OFFICER NO.": 8903561645
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Salarpuria Sattva Cadenza",
     "PROJECT ADDRESS": "HOSUR ROAD",
     "BUILDER NAME": "M\/s Pluto Realtor Private Limited",
     "BUILDER CONTACT PERSON NAME": "Sales Person",
     "MOBILE NO. OF CONTACT PERSON": 9620218379,
     "MARKETING OFFICER NAME": "Krishna Biswal",
     "MARKETING OFFICER NO.": 9040129092
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Parkwest Phase II- Maple-Tower",
     "PROJECT ADDRESS": "BASAVESHWAR NAGAR",
     "BUILDER NAME": "M\/s Relationship Properties Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Sales Person",
     "MOBILE NO. OF CONTACT PERSON": 9649706888,
     "MARKETING OFFICER NAME": "Sumit Gaurav",
     "MARKETING OFFICER NO.": 9884995820
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "G R Parkview Residency",
     "PROJECT ADDRESS": "SARJAPUR ROAD",
     "BUILDER NAME": "M\/s G R Constructions",
     "BUILDER CONTACT PERSON NAME": "NA",
     "MOBILE NO. OF CONTACT PERSON": "NA",
     "MARKETING OFFICER NAME": "Ashok Kumar Lukkani",
     "MARKETING OFFICER NO.": 8903561645
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Divinity",
     "PROJECT ADDRESS": "Mysore Road, Panthrapalya, Kengeri Hobli, Bengaluru",
     "BUILDER NAME": "Sallarpuria Sattva",
     "BUILDER CONTACT PERSON NAME": "Mohan",
     "MOBILE NO. OF CONTACT PERSON": 9742448304,
     "MARKETING OFFICER NAME": "Paramanad",
     "MARKETING OFFICER NO.": 9742448304
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Cadenza",
     "PROJECT ADDRESS": "Hosur Main Road, Kudlu Junction, Sy no 48\/4d&4e ,\nHogasandra Village, Bangalore",
     "BUILDER NAME": "Sallarpuria Sattva",
     "BUILDER CONTACT PERSON NAME": "Saurabh",
     "MOBILE NO. OF CONTACT PERSON": 9620218379,
     "MARKETING OFFICER NAME": "Deepak Panigrahy",
     "MARKETING OFFICER NO.": 9686366161
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Falcon City",
     "PROJECT ADDRESS": "Plot No 1182 Road no 1,  Kanakpura Road Bangalore-560078",
     "BUILDER NAME": "Prestige Estates Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Varad",
     "MOBILE NO. OF CONTACT PERSON": 7349771913,
     "MARKETING OFFICER NAME": "Avinash Daswani",
     "MARKETING OFFICER NO.": 7984356909
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Anugraha",
     "PROJECT ADDRESS": "Sy No-8, 8th cross Road, Sajjepalya Viilage,\nNagarbhavi-560091",
     "BUILDER NAME": "Salarpuria Anugraha",
     "BUILDER CONTACT PERSON NAME": "NA",
     "MOBILE NO. OF CONTACT PERSON": "NA",
     "MARKETING OFFICER NAME": "Avinash Daswani",
     "MARKETING OFFICER NO.": 7984356909
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Rain Tree Boulevard",
     "PROJECT ADDRESS": "Bellary Road, Indira Nagar bytrayanapura Bangalore-92",
     "BUILDER NAME": "L & T Constructions",
     "BUILDER CONTACT PERSON NAME": "Manju",
     "MOBILE NO. OF CONTACT PERSON": 9663630043,
     "MARKETING OFFICER NAME": "Avinash Daswani",
     "MARKETING OFFICER NO.": 7984356909
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Prestige Jindal City",
     "PROJECT ADDRESS": "Tumkuru Main Road, Manjunatah Nagar, Anchepalya, Bangalore-73",
     "BUILDER NAME": "Prestige South City Holdings",
     "BUILDER CONTACT PERSON NAME": "Niraj Kumar",
     "MOBILE NO. OF CONTACT PERSON": 9902001468,
     "MARKETING OFFICER NAME": "Paramanad",
     "MARKETING OFFICER NO.": 7979005488
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "MBR Shangrila",
     "PROJECT ADDRESS": "Mysore Road, Kengeri, Bangalore",
     "BUILDER NAME": "MBR Homes Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Pradeep",
     "MOBILE NO. OF CONTACT PERSON": 9591933233,
     "MARKETING OFFICER NAME": "Avinash Daswani",
     "MARKETING OFFICER NO.": 7984356909
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Nikoo Homes I\n& II",
     "PROJECT ADDRESS": "Thannisandra, Bangalore",
     "BUILDER NAME": "Bharatiya City",
     "BUILDER CONTACT PERSON NAME": "Bineet",
     "MOBILE NO. OF CONTACT PERSON": 8550811100,
     "MARKETING OFFICER NAME": "Avinash Daswani",
     "MARKETING OFFICER NO.": 7984356909
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Nikoo Homes I\n& II",
     "PROJECT ADDRESS": "Thannisandra, Bangalore",
     "BUILDER NAME": "Bharatiya City",
     "BUILDER CONTACT PERSON NAME": "Bineet",
     "MOBILE NO. OF CONTACT PERSON": 8550811100,
     "MARKETING OFFICER NAME": "Avinash Daswani",
     "MARKETING OFFICER NO.": 7984356909
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Panchamukhi Paradise",
     "PROJECT ADDRESS": "R R Nagar Banaglore",
     "BUILDER NAME": "Panchamukhi Infrastructure",
     "BUILDER CONTACT PERSON NAME": "Manju Nath",
     "MOBILE NO. OF CONTACT PERSON": 9448087778,
     "MARKETING OFFICER NAME": "Avinash Daswani",
     "MARKETING OFFICER NO.": 7984356909
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Assetz 38 & Banyan",
     "PROJECT ADDRESS": "Off Old Madras Road, Varthur Road",
     "BUILDER NAME": "Assetz Holdings LLP",
     "BUILDER CONTACT PERSON NAME": "Anil",
     "MOBILE NO. OF CONTACT PERSON": 7899312914,
     "MARKETING OFFICER NAME": "Avinash Daswani",
     "MARKETING OFFICER NO.": 7984356909
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Mahaveer Promenade",
     "PROJECT ADDRESS": "Confident Oberon Main Road K R Puram Bangalore",
     "BUILDER NAME": "Reddy structures Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Ramesh",
     "MOBILE NO. OF CONTACT PERSON": 9343866755,
     "MARKETING OFFICER NAME": "Avinash Daswani",
     "MARKETING OFFICER NO.": 7984356909
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Premier Krishna",
     "PROJECT ADDRESS": "JP Nagar, Bangalore]",
     "BUILDER NAME": "Premier Properties",
     "BUILDER CONTACT PERSON NAME": "Ahmed",
     "MOBILE NO. OF CONTACT PERSON": 9108764444,
     "MARKETING OFFICER NAME": "Avinash Daswani",
     "MARKETING OFFICER NO.": 7984356909
    },
    {
     "CITY NAME": "BANGALORE",
     "PROJECT NAME": "Clovelly",
     "PROJECT ADDRESS": "Subramanyapura Rd, Uttarahalli Bangalore",
     "BUILDER NAME": "Sobha Developers",
     "BUILDER CONTACT PERSON NAME": "Sourabh",
     "MOBILE NO. OF CONTACT PERSON": 9900049367,
     "MARKETING OFFICER NAME": "Avinash Daswani",
     "MARKETING OFFICER NO.": 7984356909
    },
    {
     "CITY NAME": "ERNAKULAM",
     "PROJECT NAME": "SFS CASA FLORA",
     "PROJECT ADDRESS": "VAZHAKKALA ERNAKULAM",
     "BUILDER NAME": "M\/s Skyline Foundations and Structures Private Limited",
     "BUILDER CONTACT PERSON NAME": "BINJU",
     "MOBILE NO. OF CONTACT PERSON": 9747800657,
     "MARKETING OFFICER NAME": "MOHAN RAJ PRASAD MANTINA",
     "MARKETING OFFICER NO.": 9989450869
    },
    {
     "CITY NAME": "ERNAKULAM",
     "PROJECT NAME": "MARINA ONE",
     "PROJECT ADDRESS": "MARINE DRIVE ERNAKULAM",
     "BUILDER NAME": "M\/s Sobha Developers",
     "BUILDER CONTACT PERSON NAME": "ANIT JACOB",
     "MOBILE NO. OF CONTACT PERSON": 9605008444,
     "MARKETING OFFICER NAME": "MOHAN RAJ PRASAD MANTINA",
     "MARKETING OFFICER NO.": 9989450869
    },
    {
     "CITY NAME": "ERNAKULAM",
     "PROJECT NAME": "Abad Golden Oak",
     "PROJECT ADDRESS": "MARADU ERNAKULAM",
     "BUILDER NAME": "M\/s.Abad Builders Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "SAIRA",
     "MOBILE NO. OF CONTACT PERSON": 8129211399,
     "MARKETING OFFICER NAME": "JIMI AMMINI PETER",
     "MARKETING OFFICER NO.": 7558898890
    },
    {
     "CITY NAME": "ERNAKULAM",
     "PROJECT NAME": "Dream Flower Avalon",
     "PROJECT ADDRESS": "KALOOR",
     "BUILDER NAME": "M\/s.Dream Flower Housing Projects Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "TENTU KRISHNAN",
     "MOBILE NO. OF CONTACT PERSON": 9562688777,
     "MARKETING OFFICER NAME": "JIMI AMMINI PETER",
     "MARKETING OFFICER NO.": 7558898890
    },
    {
     "CITY NAME": "ERNAKULAM",
     "PROJECT NAME": "KALYAN MARVELLA",
     "PROJECT ADDRESS": "GIRI NAGAR ERNAKULAM",
     "BUILDER NAME": "M\/s Kalyan Developers",
     "BUILDER CONTACT PERSON NAME": "BIJUMON C S",
     "MOBILE NO. OF CONTACT PERSON": 9072345555,
     "MARKETING OFFICER NAME": "MOHAN RAJ PRASAD MANTINA",
     "MARKETING OFFICER NO.": 9989450869
    },
    {
     "CITY NAME": "ERNAKULAM",
     "PROJECT NAME": "DD HIGHWAY PROXIMA",
     "PROJECT ADDRESS": "KUMDANOOR ERNAKULAM",
     "BUILDER NAME": "M\/s Sea Wind Realtors India Private Limited",
     "BUILDER CONTACT PERSON NAME": "JEENA",
     "MOBILE NO. OF CONTACT PERSON": 8138883957,
     "MARKETING OFFICER NAME": "MOHAN RAJ PRASAD MANTINA",
     "MARKETING OFFICER NO.": 9989450869
    },
    {
     "CITY NAME": "ERNAKULAM",
     "PROJECT NAME": "DD HIGHWAY HEIGHTS",
     "PROJECT ADDRESS": "KUMDANOOR ERNAKULAM",
     "BUILDER NAME": "M\/s Desai Homes",
     "BUILDER CONTACT PERSON NAME": "JEENA",
     "MOBILE NO. OF CONTACT PERSON": 8138883957,
     "MARKETING OFFICER NAME": "JIMI AMMINI PETER",
     "MARKETING OFFICER NO.": 7558898890
    },
    {
     "CITY NAME": "CHENNAI(Broadway)",
     "PROJECT NAME": "Abhinandan",
     "PROJECT ADDRESS": "PERAMBUR BARRACKS ROAD,OFF STRAHANS ROAD,PATTALAM,CHENNAI 600112",
     "BUILDER NAME": "KLP PROJECTS PVT LTD",
     "BUILDER CONTACT PERSON NAME": "MR.VINOTH",
     "MOBILE NO. OF CONTACT PERSON": 7823960113,
     "MARKETING OFFICER NAME": "MR. VIMAL",
     "MARKETING OFFICER NO.": 782396010
    },
    {
     "CITY NAME": "MADURAI",
     "PROJECT NAME": "VIDYA VAHINI",
     "PROJECT ADDRESS": "Paravi 1st Bit Village, Madurai",
     "BUILDER NAME": "M\/s Visvas Prmoters",
     "BUILDER CONTACT PERSON NAME": "Mr. Sundar",
     "MOBILE NO. OF CONTACT PERSON": 9843824327,
     "MARKETING OFFICER NAME": "Mohd. Zia",
     "MARKETING OFFICER NO.": 8809184475
    },
    {
     "CITY NAME": "TRIVANDRUM",
     "PROJECT NAME": "CONFIDENT FLORIS",
     "PROJECT ADDRESS": "POOJAPPURA, TRIVANDRUM",
     "BUILDER NAME": "CONFIDENT PROJECTS (INDIA) PVT LTD.,",
     "BUILDER CONTACT PERSON NAME": "DR ROY C J",
     "MOBILE NO. OF CONTACT PERSON": 9895761789,
     "MARKETING OFFICER NAME": "MINU MENON",
     "MARKETING OFFICER NO.": 9495590076
    },
    {
     "CITY NAME": "TRIVANDRUM",
     "PROJECT NAME": "CORDON LAUREL",
     "PROJECT ADDRESS": "SASTHAMANGALAM, TRIVANDRUM",
     "BUILDER NAME": "CORDON CONSTRUCTIONS & REALTORS PVT., LTD.,",
     "BUILDER CONTACT PERSON NAME": "ARUN A UNNITHAN",
     "MOBILE NO. OF CONTACT PERSON": 9895523333,
     "MARKETING OFFICER NAME": "HIRAN PRASAD",
     "MARKETING OFFICER NO.": 9591625964
    },
    {
     "CITY NAME": "TRIVANDRUM",
     "PROJECT NAME": "ARCON INSPIRE",
     "PROJECT ADDRESS": "NEAR INFOSYS, TECHNO PARK, TRIVANDRUM",
     "BUILDER NAME": "ARCON HOME BUILDERS PVT LTD.,",
     "BUILDER CONTACT PERSON NAME": "RAM NIWAS SINGH",
     "MOBILE NO. OF CONTACT PERSON": 9744233000,
     "MARKETING OFFICER NAME": "VINOTH MANI",
     "MARKETING OFFICER NO.": 9495590070
    },
    {
     "CITY NAME": "KOZHIKODE",
     "PROJECT NAME": "LAND MARK ACROPOLIS",
     "PROJECT ADDRESS": "OLAVANNA VILLAGE , IRINGALLUR,KOZHIKODE-0495- 3973100,4010400,",
     "BUILDER NAME": "CALICUT LAND MARK  BUILDERS & DEVELOPERS (INDIA)",
     "BUILDER CONTACT PERSON NAME": "CHANDRA BHANU",
     "MOBILE NO. OF CONTACT PERSON": 9388343428,
     "MARKETING OFFICER NAME": "MITHUN S",
     "MARKETING OFFICER NO.": 7907742045
    },
    {
     "CITY NAME": "KOZHIKODE",
     "PROJECT NAME": "APPOLO OASIS",
     "PROJECT ADDRESS": "MANJERI",
     "BUILDER NAME": "CALICUT APPOLO",
     "BUILDER CONTACT PERSON NAME": "FAISAL,OM ABDUL",
     "MOBILE NO. OF CONTACT PERSON": 9895068286,
     "MARKETING OFFICER NAME": "MITHUN S",
     "MARKETING OFFICER NO.": 7907742045
    },
    {
     "CITY NAME": "CHANDIGARH",
     "PROJECT NAME": "MAYA GARDER CITY",
     "PROJECT ADDRESS": "ZIRAKPUR",
     "BUILDER NAME": "MAYA GARDEN",
     "BUILDER CONTACT PERSON NAME": "AMIT MITTAL",
     "MOBILE NO. OF CONTACT PERSON": 9814724100,
     "MARKETING OFFICER NAME": "Sunil Choudhary",
     "MARKETING OFFICER NO.": 9928139674
    },
    {
     "CITY NAME": "CHANDIGARH",
     "PROJECT NAME": "PALM MEDOW",
     "PROJECT ADDRESS": "KHARAR, MOHALI",
     "BUILDER NAME": "UBER PALM MEDOWS",
     "BUILDER CONTACT PERSON NAME": "Yogender",
     "MOBILE NO. OF CONTACT PERSON": 9814046324,
     "MARKETING OFFICER NAME": "Sunil Choudhary",
     "MARKETING OFFICER NO.": 9928139675
    },
    {
     "CITY NAME": "CHANDIGARH",
     "PROJECT NAME": "PALM VILLAGE",
     "PROJECT ADDRESS": "SECTOR 126,KHARAR, MOHALI",
     "BUILDER NAME": "M\/s BEE GEE\nBuildtech (BGB)",
     "BUILDER CONTACT PERSON NAME": "Devender Kumar Kalia",
     "MOBILE NO. OF CONTACT PERSON": 9646000545,
     "MARKETING OFFICER NAME": "Sunil Choudhary",
     "MARKETING OFFICER NO.": 9928139676
    },
    {
     "CITY NAME": "CHANDIGARH",
     "PROJECT NAME": "IMPERIAL HEIGHT",
     "PROJECT ADDRESS": "SECTOR 115,KHARAR",
     "BUILDER NAME": "WWICS ESTATES BUILDERS",
     "BUILDER CONTACT PERSON NAME": "SUKHWINDER SINGH",
     "MOBILE NO. OF CONTACT PERSON": 9357993579,
     "MARKETING OFFICER NAME": "Sunil Choudhary",
     "MARKETING OFFICER NO.": 9928139677
    },
    {
     "CITY NAME": "CHANDIGARH",
     "PROJECT NAME": "HERMITAGE PARK",
     "PROJECT ADDRESS": "DHAKOLI, ZIRAK PUR, MOHALI",
     "BUILDER NAME": "PARADIGM THE HERMITAGE PARK",
     "BUILDER CONTACT PERSON NAME": "KAMAL JINDAL",
     "MOBILE NO. OF CONTACT PERSON": 9814112012,
     "MARKETING OFFICER NAME": "Sunil Choudhary",
     "MARKETING OFFICER NO.": 9928139678
    },
    {
     "CITY NAME": "CHANDIGARH",
     "PROJECT NAME": "GREEN LOTUS SAKSHAM",
     "PROJECT ADDRESS": "ZIRZKPUR",
     "BUILDER NAME": "MAYA BUILDERS",
     "BUILDER CONTACT PERSON NAME": "AMIT MITTAL",
     "MOBILE NO. OF CONTACT PERSON": 9814724100,
     "MARKETING OFFICER NAME": "Sunil Choudhary",
     "MARKETING OFFICER NO.": 9928139679
    },
    {
     "CITY NAME": "CHANDIGARH",
     "PROJECT NAME": "COD-1 PLATINA FLOOR",
     "PROJECT ADDRESS": "KHARAR",
     "BUILDER NAME": "SINGLA BUILDER & PROMOTORS",
     "BUILDER CONTACT PERSON NAME": "AMIT BHARGAVA",
     "MOBILE NO. OF CONTACT PERSON": 7087106115,
     "MARKETING OFFICER NAME": "Sunil Choudhary",
     "MARKETING OFFICER NO.": 9928139680
    },
    {
     "CITY NAME": "CHANDIGARH",
     "PROJECT NAME": "PALM RESIDENCY",
     "PROJECT ADDRESS": "KHARAR",
     "BUILDER NAME": "MANOHAR INFRA",
     "BUILDER CONTACT PERSON NAME": "SUMIT KUMAR",
     "MOBILE NO. OF CONTACT PERSON": 9216417416,
     "MARKETING OFFICER NAME": "Sunil Choudhary",
     "MARKETING OFFICER NO.": 9928139681
    },
    {
     "CITY NAME": "CHANDIGARH",
     "PROJECT NAME": "COD-115",
     "PROJECT ADDRESS": "KHARAR",
     "BUILDER NAME": "SINGLA BUILDER & PROMOTORS",
     "BUILDER CONTACT PERSON NAME": "AMIT BHARGAVA",
     "MOBILE NO. OF CONTACT PERSON": 7087106115,
     "MARKETING OFFICER NAME": "Sunil Choudhary",
     "MARKETING OFFICER NO.": 9928139682
    },
    {
     "CITY NAME": "JAIPUR",
     "PROJECT NAME": "ASHIANA UMANG",
     "PROJECT ADDRESS": "Ajmer Road, Tehsil Sanganer Near Mahindra SEZ Jhai, Rajasthan 302026",
     "BUILDER NAME": "Ashiana Manglam Builder",
     "BUILDER CONTACT PERSON NAME": "Mr. Gajendra Rajawat",
     "MOBILE NO. OF CONTACT PERSON": 8003391688,
     "MARKETING OFFICER NAME": "Mr. Mohit Goyal",
     "MARKETING OFFICER NO.": 8469877086
    },
    {
     "CITY NAME": "JAIPUR ASHIANA GREENS"
    },
    {
     "CITY NAME": "Sikar Road, Near Sun City , Vidyadhar"
    },
    {
     "CITY NAME": "Nagar, jaipur Rajasthan 303704 Ashiana Housing Ltd. Mr.Nitin Kathri"
    },
    {
     "CITY NAME": 7568399995
    },
    {
     "CITY NAME": "Mr. Hemant Kumar"
    },
    {
     "CITY NAME": "Lakhera 9829382593"
    },
    {
     "CITY NAME": "JAIPUR",
     "PROJECT NAME": "GULMOHAR GARDENS",
     "PROJECT ADDRESS": "Tehsil Manpur Bhatawala, Vatika RoaD, Revenue Village Vatika, Sanganer Jaipur",
     "BUILDER NAME": "Ashiana Manglam Builder",
     "BUILDER CONTACT PERSON NAME": "Mr. Gajendra Rajawat",
     "MOBILE NO. OF CONTACT PERSON": 8003391688,
     "MARKETING OFFICER NAME": "Mr. Saurabh Gupta",
     "MARKETING OFFICER NO.": 9610741701
    },
    {
     "CITY NAME": "JAIPUR",
     "PROJECT NAME": "VRINDA GARDENS",
     "PROJECT ADDRESS": "Near RTO Office, Village, Tehsil Kho Nagoriyan, Sanganer , Jagatpura, Jaipur",
     "BUILDER NAME": "Vista Housing",
     "BUILDER CONTACT PERSON NAME": "Mr. Amit",
     "MOBILE NO. OF CONTACT PERSON": 8721863988,
     "MARKETING OFFICER NAME": "Mr. Niteesh Bhardwaj",
     "MARKETING OFFICER NO.": 7665233375
    },
    {
     "CITY NAME": "JAIPUR",
     "PROJECT NAME": "GREEN MEADOWS",
     "PROJECT ADDRESS": "Tonk Road Sitapura, Beelwa Kalan Rajasthan 303905",
     "BUILDER NAME": "Unique Builders",
     "BUILDER CONTACT PERSON NAME": "Mr. Deepak Wadwa",
     "MOBILE NO. OF CONTACT PERSON": 9828300007,
     "MARKETING OFFICER NAME": "Mr. Bantoo Mangal",
     "MARKETING OFFICER NO.": 9638889204
    },
    {
     "CITY NAME": "JAIPUR",
     "PROJECT NAME": "MAHIMA BELEVISTA",
     "PROJECT ADDRESS": "Opposite JNU Campus-2, Near RTO Office, Jagatpura, Jaipur,303012",
     "BUILDER NAME": "Mahima Real Estate",
     "BUILDER CONTACT PERSON NAME": "Mr. Direndra Madan",
     "MOBILE NO. OF CONTACT PERSON": 9772210760,
     "MARKETING OFFICER NAME": "Mrs. Pragya Sharma",
     "MARKETING OFFICER NO.": 9503031908
    },
    {
     "CITY NAME": "JAIPUR",
     "PROJECT NAME": "BHAVYA GREENS",
     "PROJECT ADDRESS": "Ramnagaria , Jagatpura Jaipur, Rajasthan\n,302017",
     "BUILDER NAME": "Bhavya Greens Builders",
     "BUILDER CONTACT PERSON NAME": "Mr. Anuj Arora",
     "MOBILE NO. OF CONTACT PERSON": 9829288113,
     "MARKETING OFFICER NAME": "Mr. Niteesh Bhardwaj",
     "MARKETING OFFICER NO.": 7665233375
    },
    {
     "CITY NAME": "JAIPUR",
     "PROJECT NAME": "THE CREST",
     "PROJECT ADDRESS": "A-4, Jawahar Circle, Sudarshan Enclave, Govind Vihar , Surajpura, Durgapura, Jaipur",
     "BUILDER NAME": "F S Housing Ltd.",
     "BUILDER CONTACT PERSON NAME": "Mr. Ashok Khandelwal",
     "MOBILE NO. OF CONTACT PERSON": 9829250040,
     "MARKETING OFFICER NAME": "Mr. Saurabh Gupta",
     "MARKETING OFFICER NO.": 960741701
    },
    {
     "CITY NAME": "JAIPUR",
     "PROJECT NAME": "KEDIA'Z CORPORATE CLUB",
     "PROJECT ADDRESS": "Gandhi Path West, Vaishali Nagar Extension, Jaipur Rajasthan 302021",
     "BUILDER NAME": "Kedia Real Estate LLP",
     "BUILDER CONTACT PERSON NAME": "Mr. Nirmal Kumar Kedia",
     "MOBILE NO. OF CONTACT PERSON": 9829018056,
     "MARKETING OFFICER NAME": "Mr. Hemant Kumar Lakhera",
     "MARKETING OFFICER NO.": 9829382593
    },
    {
     "CITY NAME": "JAIPUR",
     "PROJECT NAME": "ARG ANANTA",
     "PROJECT ADDRESS": "Near NRI Colony, Chak Gatore, Jagatpura, Tehsil Sanganer, Jaipur",
     "BUILDER NAME": "ARG CG Developers LLP",
     "BUILDER CONTACT PERSON NAME": "Mr. Sanjeet Sharma",
     "MOBILE NO. OF CONTACT PERSON": 9982829666,
     "MARKETING OFFICER NAME": "Mr. Dileep Goyal",
     "MARKETING OFFICER NO.": 9687678749
    },
    {
     "CITY NAME": "Mohali",
     "PROJECT NAME": "GBP Athense-I, -II",
     "PROJECT ADDRESS": "Zirakpur",
     "BUILDER NAME": "GUPTA BUILDERS & PROMOTERS",
     "BUILDER CONTACT PERSON NAME": "MR. PARDEEP GUPTA",
     "MOBILE NO. OF CONTACT PERSON": 9877884996,
     "MARKETING OFFICER NAME": "MR. RAHUL DOGRA",
     "MARKETING OFFICER NO.": 9857066766
    },
    {
     "CITY NAME": "Gurgaon",
     "PROJECT NAME": "M3M Sky City",
     "PROJECT ADDRESS": "Sector.65,Gurgaon",
     "BUILDER NAME": "M3M Sky City",
     "BUILDER CONTACT PERSON NAME": "Mrs.Nikita Yadav",
     "MOBILE NO. OF CONTACT PERSON": "NA",
     "MARKETING OFFICER NAME": "Mr.Kumar Pankaj",
     "MARKETING OFFICER NO.": 8146436757
    },
    {
     "CITY NAME": "GAUTAM BUDH NAGAR",
     "PROJECT NAME": "M\/S ACE DIVINO",
     "PROJECT ADDRESS": "SECTOR 1, GREATER NOIDA WEST",
     "BUILDER NAME": "M\/S ACE GROUP",
     "BUILDER CONTACT PERSON NAME": "RAJEEV KUMAR",
     "MOBILE NO. OF CONTACT PERSON": 9958973331,
     "MARKETING OFFICER NAME": "MUKESH KUMAR",
     "MARKETING OFFICER NO.": 9803773781
    },
    {
     "CITY NAME": "GAUTAM BUDH NAGAR",
     "PROJECT NAME": "M\/S ATS LE GRANDIOSE",
     "PROJECT ADDRESS": "SECTOR 150, NOIDA",
     "BUILDER NAME": "M\/S ATS NOBILITY ESTATE PVT LTD",
     "BUILDER CONTACT PERSON NAME": "SACHI",
     "MOBILE NO. OF CONTACT PERSON": 9971427723,
     "MARKETING OFFICER NAME": "D P SINGH",
     "MARKETING OFFICER NO.": 9210320126
    },
    {
     "CITY NAME": "UDAIPUR",
     "PROJECT NAME": "The Universe",
     "PROJECT ADDRESS": "Village Titardi,Tehshil-Girwa,Udaipur",
     "BUILDER NAME": "M\/s Ridhi Siddhi Infra  Projects Pvt. Ltd",
     "BUILDER CONTACT PERSON NAME": "AMIT SETH",
     "MOBILE NO. OF CONTACT PERSON": 8003443444,
     "MARKETING OFFICER NAME": "SAPAN BHATI",
     "MARKETING OFFICER NO.": 8226012425
    },
    {
     "CITY NAME": "UDAIPUR",
     "PROJECT NAME": "Celebration Residencey",
     "PROJECT ADDRESS": "Plot No a-11,A-12, Bhuwana ,Udaipur",
     "BUILDER NAME": "Mahalakshmi Buildhome Ltd",
     "BUILDER CONTACT PERSON NAME": "Dinesh Bjaj",
     "MOBILE NO. OF CONTACT PERSON": 9828555001,
     "MARKETING OFFICER NAME": "SAPAN BHATI",
     "MARKETING OFFICER NO.": 8226012425
    },
    {
     "CITY NAME": "UDAIPUR",
     "PROJECT NAME": "Lake City Residency",
     "PROJECT ADDRESS": "Plot No 1-3 Z&12 to 14, Near 100 ft Road,bhuwana,udaipur",
     "BUILDER NAME": "Mahalakshmi Buildhome Ltd",
     "BUILDER CONTACT PERSON NAME": "Dinesh Bjaj",
     "MOBILE NO. OF CONTACT PERSON": 9828555001,
     "MARKETING OFFICER NAME": "SAPAN BHATI",
     "MARKETING OFFICER NO.": 8226012425
    },
    {
     "CITY NAME": "UDAIPUR",
     "PROJECT NAME": "ARCHI ROYAL CITY",
     "PROJECT ADDRESS": "Plot No 1,Revenue Village Dholimagri,Pratap Nagar,UDAIPUR",
     "BUILDER NAME": "M\/S ARCHI CIVIL CONSTRUCTION PVT LTD",
     "BUILDER CONTACT PERSON NAME": "LOKESH MALAHARA",
     "MOBILE NO. OF CONTACT PERSON": 8003597907,
     "MARKETING OFFICER NAME": "SAPAN BHATI",
     "MARKETING OFFICER NO.": 8226012425
    },
    {
     "CITY NAME": "UDAIPUR",
     "PROJECT NAME": "ARCHI PEACE PARK",
     "PROJECT ADDRESS": "REVENUE VILLAGE MANWA KHERA UDAIPUR",
     "BUILDER NAME": "M\/S ARCHI CIVIL CONSTRUCTION PVT LTD",
     "BUILDER CONTACT PERSON NAME": "LOKESH MALAHARA",
     "MOBILE NO. OF CONTACT PERSON": 8003597907,
     "MARKETING OFFICER NAME": "SAPAN BHATI",
     "MARKETING OFFICER NO.": 8226012425
    },
    {
     "CITY NAME": "UDAIPUR",
     "PROJECT NAME": "Mahaviram",
     "PROJECT ADDRESS": "sector -4,Hiran magri,Udaipur",
     "BUILDER NAME": "Dharti Infra Projects  Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Siddharth Agarwal",
     "MOBILE NO. OF CONTACT PERSON": 9828848939,
     "MARKETING OFFICER NAME": "VISHAL D THAKKAR",
     "MARKETING OFFICER NO.": 8866001607
    },
    {
     "CITY NAME": "UDAIPUR",
     "PROJECT NAME": "Landmark Treasure Town",
     "PROJECT ADDRESS": "Kharol Colony",
     "BUILDER NAME": "M\/s Dazling Properties Pvt.ltd",
     "BUILDER CONTACT PERSON NAME": "Rohit Chobasia",
     "MOBILE NO. OF CONTACT PERSON": 9314643198,
     "MARKETING OFFICER NAME": "VISHAL D THAKKAR",
     "MARKETING OFFICER NO.": 8866001607
    },
    {
     "CITY NAME": "UDAIPUR",
     "PROJECT NAME": "Serenity",
     "PROJECT ADDRESS": "Near Dainik Bhaskar Office,shelio ki bari road,New Fatehpura, udaipur",
     "BUILDER NAME": "Sakar Builders",
     "BUILDER CONTACT PERSON NAME": "Abhishek",
     "MOBILE NO. OF CONTACT PERSON": 7737738001,
     "MARKETING OFFICER NAME": "VISHAL D THAKKAR",
     "MARKETING OFFICER NO.": 8866001607
    },
    {
     "CITY NAME": "KOTA",
     "PROJECT NAME": "PLATINA",
     "PROJECT ADDRESS": "PLOT NO KCP 1 KUNHARI",
     "BUILDER NAME": "M\/S SILVER WINGS LIFE  SPACES",
     "BUILDER CONTACT PERSON NAME": "ZULFIKAAR PATHAN",
     "MOBILE NO. OF CONTACT PERSON": 9414178635,
     "MARKETING OFFICER NAME": "PAWAN KUMARB DWIVEDI",
     "MARKETING OFFICER NO.": 8005267377
    },
    {
     "CITY NAME": "KOTA",
     "PROJECT NAME": "PARK VIEW",
     "PROJECT ADDRESS": "CP1, BALAJI MARKET SHRINATHPURAM KOTA",
     "BUILDER NAME": "M\/S RAJAT CITY DEVELOPERS LIMITED",
     "BUILDER CONTACT PERSON NAME": "ZULFIKAAR PATHAN",
     "MOBILE NO. OF CONTACT PERSON": 9414178635,
     "MARKETING OFFICER NAME": "PAWAN KUMARB DWIVEDI",
     "MARKETING OFFICER NO.": 8005267377
    },
    {
     "CITY NAME": "GUWAHATI",
     "PROJECT NAME": "PRAGATI RESIDENCY",
     "PROJECT ADDRESS": "BAMUNIMAIDAM,GUWAHATI-21",
     "BUILDER NAME": "M\/S PRAGATI",
     "BUILDER CONTACT PERSON NAME": "PARESH KUMAR GOGOI",
     "MOBILE NO. OF CONTACT PERSON": 9435543455,
     "MARKETING OFFICER NAME": "Dharmendra Kumar",
     "MARKETING OFFICER NO.": 9401885562
    },
    {
     "CITY NAME": "GUWAHATI",
     "PROJECT NAME": "GOKUL PRIDE",
     "PROJECT ADDRESS": "BARSHAPARA, GUWAHATI-25",
     "BUILDER NAME": "ASHOKA ASSOCIATES",
     "BUILDER CONTACT PERSON NAME": "SURESH MITTAL",
     "MOBILE NO. OF CONTACT PERSON": 9435015614,
     "MARKETING OFFICER NAME": "Dharmendra Kumar",
     "MARKETING OFFICER NO.": 9401885562
    },
    {
     "CITY NAME": "GUWAHATI",
     "PROJECT NAME": "NCS PLAZZO",
     "PROJECT ADDRESS": "ADABARI , GUWAHATI-14",
     "BUILDER NAME": "NCS ESTATE PVT LTD",
     "BUILDER CONTACT PERSON NAME": "SHUBHAM SARAWAGI",
     "MOBILE NO. OF CONTACT PERSON": 9435477285,
     "MARKETING OFFICER NAME": "Dharmendra Kumar",
     "MARKETING OFFICER NO.": 9401885562
    },
    {
     "CITY NAME": "GUWAHATI",
     "PROJECT NAME": "BABYLON",
     "PROJECT ADDRESS": "SAUKUCHI, GUWAHATI- 34",
     "BUILDER NAME": "SRKM STEEL PVT LTD",
     "BUILDER CONTACT PERSON NAME": "SAURABH KHETAWAT",
     "MOBILE NO. OF CONTACT PERSON": 9864090002,
     "MARKETING OFFICER NAME": "Dharmendra Kumar",
     "MARKETING OFFICER NO.": 9401885562
    },
    {
     "CITY NAME": "Sonarpur",
     "PROJECT NAME": "IDEAL AURUM",
     "PROJECT ADDRESS": "50, J L Nehru Road, 11th Floor, Kolkata West Bengal – 700071.",
     "BUILDER NAME": "IDEAL Nirman LLP",
     "BUILDER CONTACT PERSON NAME": "Mr. Ashish",
     "MOBILE NO. OF CONTACT PERSON": 9830056962,
     "MARKETING OFFICER NAME": "Debbrath Kumar",
     "MARKETING OFFICER NO.": 9836811722
    },
    {
     "CITY NAME": "HOWRAH",
     "PROJECT NAME": "GANGES SKYYY",
     "PROJECT ADDRESS": "At premises No. 6\/7, New Seal Lane, P.O.\n& P.S. Howrah, Howrah 711101",
     "BUILDER NAME": "M\/S KANHAIYA REALTORS PVT LTD",
     "BUILDER CONTACT PERSON NAME": "Mr. Suraj Singh",
     "MOBILE NO. OF CONTACT PERSON": 9830501411,
     "MARKETING OFFICER NAME": "Debbrath Kumar",
     "MARKETING OFFICER NO.": 9836811722
    },
    {
     "CITY NAME": "CHINSURAH",
     "PROJECT NAME": "SANJABANI ABASAN",
     "PROJECT ADDRESS": "SANJEEVANI ABASAN, CHINSURAH",
     "BUILDER NAME": "M\/S MONDAL COSNTRUCTION CO. LTD,",
     "BUILDER CONTACT PERSON NAME": "Mr. Arun",
     "MOBILE NO. OF CONTACT PERSON": 9836694260,
     "MARKETING OFFICER NAME": "Debbrath Kumar",
     "MARKETING OFFICER NO.": 9836811722
    },
    {
     "CITY NAME": "SONARPUR",
     "PROJECT NAME": "Rajwada lake bliss",
     "PROJECT ADDRESS": "Kamalgachi, Sonarpur Road, Sonarpur, WB",
     "BUILDER NAME": "M\/S Rajwada Developers",
     "BUILDER CONTACT PERSON NAME": "Mr. Biswajit",
     "MOBILE NO. OF CONTACT PERSON": 8820607015,
     "MARKETING OFFICER NAME": "Debbrath Kumar",
     "MARKETING OFFICER NO.": 9836811722
    },
    {
     "CITY NAME": "KHARAGPUR",
     "PROJECT NAME": "NEW COSMOCITY",
     "PROJECT ADDRESS": "Saha Chowk, NH -6, Mumbai Road, Malancha, Kharagpur- 721304, Distt Paschim Medinipur",
     "BUILDER NAME": "M\/S VIVEK REALTY\n& RESORT PVT. LTD",
     "BUILDER CONTACT PERSON NAME": "Mr. CHANDRA KANT",
     "MOBILE NO. OF CONTACT PERSON": 9647001235,
     "MARKETING OFFICER NAME": "Debbrath Kumar",
     "MARKETING OFFICER NO.": 9836811722
    },
    {
     "CITY NAME": "KHARAGPUR",
     "PROJECT NAME": "NEW KOLKATA PRAYAG",
     "PROJECT ADDRESS": "449\/A\/2, GT Road, Dist: Hoogly, PS. Serampore, Mouza-Mahesh, Hoogly, West Bengal, Pin-712202",
     "BUILDER NAME": "M\/S Alcove Developers LLP",
     "BUILDER CONTACT PERSON NAME": "Mr. Sanatan Dutta",
     "MOBILE NO. OF CONTACT PERSON": 9836968996,
     "MARKETING OFFICER NAME": "Debbrath Kumar",
     "MARKETING OFFICER NO.": 9836811722
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "Sukhobrishti",
     "PROJECT ADDRESS": "Plot no E1\/E2,Rajarhat,NewtOWN, Action Area III,Kolkata",
     "BUILDER NAME": "Bengal Shapoorji Housing Development Pvt. Ltd.",
     "BUILDER CONTACT PERSON NAME": "Mallika Bhaskar",
     "MOBILE NO. OF CONTACT PERSON": 9812651699,
     "MARKETING OFFICER NAME": "Utsab Behera",
     "MARKETING OFFICER NO.": 7381017792
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "Urbana",
     "PROJECT ADDRESS": "782 & 783,Anandapur,PO East Kolkata Township Project, Kolkata 700107",
     "BUILDER NAME": "Bengal NRI Complex",
     "BUILDER CONTACT PERSON NAME": "S Roy",
     "MOBILE NO. OF CONTACT PERSON": 9836760508,
     "MARKETING OFFICER NAME": "Mrityunjay Singh",
     "MARKETING OFFICER NO.": 8697747326
    },
    {
     "CITY NAME": "KOLKATA Emami City"
    },
    {
     "CITY NAME": "Premises no. 2, Jessore Road, Holding  no. 380(N), 1108(O), Cal-Jessore"
    },
    {
     "CITY NAME": "Road, Kolkata"
    },
    {
     "CITY NAME": "Ltd."
    },
    {
     "CITY NAME": "Emami Infrastructure"
    },
    {
     "CITY NAME": "K K Sinha 7679600600 Sandeep Kumar 8109058055"
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "Ideal Exotica",
     "PROJECT ADDRESS": "No-21,Pramatha Chowdhury Sarani),P.S. New Alipore, Ward No-81,Kolkata 700053",
     "BUILDER NAME": "Ideal Real Estates Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Mukesh Agarwal",
     "MOBILE NO. OF CONTACT PERSON": "03322821548\/0513\/5410",
     "MARKETING OFFICER NAME": "Sandip Mallick",
     "MARKETING OFFICER NO.": 9688830475
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "Siddha Pines",
     "PROJECT ADDRESS": "P.S. Airport, Dist North 24 Parganas, Pin 700136",
     "BUILDER NAME": "Siddha Real Estate Development Pvt. Ltd.",
     "BUILDER CONTACT PERSON NAME": "Nitu Singh",
     "MOBILE NO. OF CONTACT PERSON": 3340401010,
     "MARKETING OFFICER NAME": "Bivas Bar",
     "MARKETING OFFICER NO.": 7604018703
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "Siddha Water front",
     "PROJECT ADDRESS": "Old Calcutta Road, Mouza Patulia, J L No\nP. S Khardah, Dist – North 24 Paraganas, Kolkata-700119",
     "BUILDER NAME": "Siddha Waterfront LLP",
     "BUILDER CONTACT PERSON NAME": "Nitu Singh",
     "MOBILE NO. OF CONTACT PERSON": "03340305000\/033400\n71 500",
     "MARKETING OFFICER NAME": "Bivas Bar",
     "MARKETING OFFICER NO.": 7604018703
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "PS Panache",
     "PROJECT ADDRESS": "JL 18,Mouza Mahisbathan,Touzi No 145,Electronic complex,within the Local limits of Bidhanagar Muncipality,District 24 Parganas(North).",
     "BUILDER NAME": "PS Srijan Real Ventures LLP",
     "BUILDER CONTACT PERSON NAME": "Trishit Gangopadhayay",
     "MOBILE NO. OF CONTACT PERSON": 9073950551,
     "MARKETING OFFICER NAME": "Soumitra Kisku",
     "MARKETING OFFICER NO.": 9445836830
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "Siddha Eden Lake Ville",
     "PROJECT ADDRESS": "Premises No 561, Bonhoogly Arable Land, Lake View Park Road. P.S Baranagar, Ward No 15, North 24 PNGS",
     "BUILDER NAME": "Siddha Real Estate Development Pvt. Ltd.",
     "BUILDER CONTACT PERSON NAME": "Nitu Singh",
     "MOBILE NO. OF CONTACT PERSON": 3340401010,
     "MARKETING OFFICER NAME": "Anurag Thakur",
     "MARKETING OFFICER NO.": 9073999952
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "Shankh Mani",
     "PROJECT ADDRESS": "Premises No. 338, Motilal Gupta Road, Ward No. 122 of KMC, Kolkata,  700082",
     "BUILDER NAME": "Mani Enclave Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Vivek Jhunjhunwala",
     "MOBILE NO. OF CONTACT PERSON": 9830273506,
     "MARKETING OFFICER NAME": "Mrityunjay Singh",
     "MARKETING OFFICER NO.": 8697747326
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "DTC Southern Heights",
     "PROJECT ADDRESS": "Mouza Daulatpur & Hanspukuria, P.O. Joka, on Diamond Harbor Road, next Vivekananda mission school, P.S. Thakurpukur, Dist south 24 Parganas, Kolkata, 700104",
     "BUILDER NAME": "DTC Projects Pvt. Ltd.",
     "BUILDER CONTACT PERSON NAME": "Abhishek Goswami",
     "MOBILE NO. OF CONTACT PERSON": 9830296663,
     "MARKETING OFFICER NAME": "Sandeep Kumar",
     "MARKETING OFFICER NO.": 3330566477
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "The Lakewood Estate",
     "PROJECT ADDRESS": "Patuli, EM Byepass, Holding No. 266, Garagachha, Ward No. 1 of Rajpur  Sonarpur Municipality, PS Sonarpur, Kolkata, 700094",
     "BUILDER NAME": "Unimarkmirania Projects LLP",
     "BUILDER CONTACT PERSON NAME": "Santanu Ghosh",
     "MOBILE NO. OF CONTACT PERSON": 8334832000,
     "MARKETING OFFICER NAME": "Sandip Mallick",
     "MARKETING OFFICER NO.": 9688830475
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "Sidha Sky",
     "PROJECT ADDRESS": "Premises No. 33A (Formerly 33A, 33B and 33C), Canal South Road, P.S Tangra, Ward No. 57 of KMC, Kolkata 700015",
     "BUILDER NAME": "Sidha Infradev LLP",
     "BUILDER CONTACT PERSON NAME": "Gaurav",
     "MOBILE NO. OF CONTACT PERSON": 7044472838,
     "MARKETING OFFICER NAME": "Mrityunjay Singh",
     "MARKETING OFFICER NO.": 8697747326
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "Aspirations Orchid",
     "PROJECT ADDRESS": "Premises No.4, Naktala Road, PS patuli,Formerly Jadavpur, Ward No.100 of KMC Kolkata-700047",
     "BUILDER NAME": "Aspirations Towers Pvt. Ltd.",
     "BUILDER CONTACT PERSON NAME": "Raja Bose",
     "MOBILE NO. OF CONTACT PERSON": 7278155555,
     "MARKETING OFFICER NAME": "Utsab Behera",
     "MARKETING OFFICER NO.": 7381017792
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "Rare Earth",
     "PROJECT ADDRESS": "93 Narkel Danga opposite lake district near Swabhumi .Kol-700054",
     "BUILDER NAME": "Prasad Group",
     "BUILDER CONTACT PERSON NAME": "Harry John",
     "MOBILE NO. OF CONTACT PERSON": 9903022950,
     "MARKETING OFFICER NAME": "Sumit Chatterjee",
     "MARKETING OFFICER NO.": 9786500613
    },
    {
     "CITY NAME": "KOLKATA",
     "PROJECT NAME": "Avidipta Phase II",
     "PROJECT ADDRESS": "EM Bypass Kolkata",
     "BUILDER NAME": "Bengal Peerless Housing Development Co. Ltd.",
     "BUILDER CONTACT PERSON NAME": "Shreya Ghosh",
     "MOBILE NO. OF CONTACT PERSON": 9748125090,
     "MARKETING OFFICER NAME": "Sandip Mallick",
     "MARKETING OFFICER NO.": 9688830475
    },
    {
     "CITY NAME": "AGRA",
     "PROJECT NAME": "SHANKER GREEN",
     "PROJECT ADDRESS": "PLOT NO 1 TAJ NAGARI PHASE II AGRA",
     "BUILDER NAME": "SWAMI NIRMAN PVT",
     "BUILDER CONTACT PERSON NAME": "MR. NAVEEN AGARWAL",
     "MOBILE NO. OF CONTACT PERSON": 9837777772,
     "MARKETING OFFICER NAME": "MR. RAJIV CHAUHAN",
     "MARKETING OFFICER NO.": 7534069069
    },
    {
     "CITY NAME": "LTD"
    },
    {
     "CITY NAME": "MEERUT",
     "PROJECT NAME": "SHEELKUNJ RE REVISED",
     "PROJECT ADDRESS": "SHEELKUNJ ROORKEE ROAD MEERUT UP",
     "BUILDER NAME": "M\/S INDUS VALLEY PROMOTORS LIMITED",
     "BUILDER CONTACT PERSON NAME": "AJAY GUPTA\/SANJAY GUPTA",
     "MOBILE NO. OF CONTACT PERSON": 9412706655,
     "MARKETING OFFICER NAME": "Vikas Garg -",
     "MARKETING OFFICER NO.": 9458202073
    },
    {
     "CITY NAME": "MEERUT",
     "PROJECT NAME": "NEW SAKET",
     "PROJECT ADDRESS": "VILLAGE ABDULLAPUR, KILA ROAD,MEERUT UP",
     "BUILDER NAME": "INPROSPER INFRASTRUCTURE LLP",
     "BUILDER CONTACT PERSON NAME": "ANIL KUMAR BANSA",
     "MOBILE NO. OF CONTACT PERSON": 9582237097,
     "MARKETING OFFICER NAME": "Mohit -",
     "MARKETING OFFICER NO.": 8010768063
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "Eldeco Saubhagyam",
     "PROJECT ADDRESS": "9 D\/GH-1 ,Vrindavan Yojna ,Rai Bareilly Road ,Lucknow",
     "BUILDER NAME": "M\/s Eldeco Housing and  Industries Limited",
     "BUILDER CONTACT PERSON NAME": "Mohit Bhatia",
     "MOBILE NO. OF CONTACT PERSON": 9792102978,
     "MARKETING OFFICER NAME": "Aunjani",
     "MARKETING OFFICER NO.": 7385796645
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "Sushant Gof City",
     "PROJECT ADDRESS": "Sultanpur Road ,Near Cantonment ,Lucknow",
     "BUILDER NAME": "M\/s Ansal Housing Properties and Infrastructure Limited",
     "BUILDER CONTACT PERSON NAME": "Padmesh",
     "MOBILE NO. OF CONTACT PERSON": 9451017007,
     "MARKETING OFFICER NAME": "Kanchi",
     "MARKETING OFFICER NO.": 9918301293
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "Tulsiani Golf View Appartment",
     "PROJECT ADDRESS": "Group Housing 3 ,Golf community,  Sultanpur Road\n,Lucknow",
     "BUILDER NAME": "M\/s Tulsiani Construction & Developers Ltd",
     "BUILDER CONTACT PERSON NAME": "Tripathi",
     "MOBILE NO. OF CONTACT PERSON": 9235506486,
     "MARKETING OFFICER NAME": "Pankaj",
     "MARKETING OFFICER NO.": 6388563042
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "BBD Green city\n,sunbreeze-1",
     "PROJECT ADDRESS": "Faizabad road ,Gomti Nagar ,Adjecent BBD Engineering college ,Lucknow",
     "BUILDER NAME": "M\/s Viraj Constructions  Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Satish Rai",
     "MOBILE NO. OF CONTACT PERSON": 7388899917,
     "MARKETING OFFICER NAME": "abhishek",
     "MARKETING OFFICER NO.": 9967582526
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "Shalimar Grand",
     "PROJECT ADDRESS": "10 Jopling road ,Lucknow",
     "BUILDER NAME": "M\/s Shalimar Corp Limited",
     "BUILDER CONTACT PERSON NAME": "Faizal",
     "MOBILE NO. OF CONTACT PERSON": 7000258744,
     "MARKETING OFFICER NAME": "Pankaj",
     "MARKETING OFFICER NO.": 6388563042
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "Shalimar Gallant",
     "PROJECT ADDRESS": "Mahanagar ,Oppo ,Saroj Nursing home\n,Dandiya Market ,Lucknow",
     "BUILDER NAME": "M\/s Shalimar Corp Limited",
     "BUILDER CONTACT PERSON NAME": "Faizal",
     "MOBILE NO. OF CONTACT PERSON": 7000258744,
     "MARKETING OFFICER NAME": "Neha",
     "MARKETING OFFICER NO.": 7800003567
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "Spring Greens(Phase II)",
     "PROJECT ADDRESS": "327 ,Anaura ,Adjoining  Ramswroop  school ,Faizabad Road\n,Lucknow",
     "BUILDER NAME": "M\/s Spring Developers",
     "BUILDER CONTACT PERSON NAME": "Shahnaz",
     "MOBILE NO. OF CONTACT PERSON": 9235606063,
     "MARKETING OFFICER NAME": "Pankaj",
     "MARKETING OFFICER NO.": 6388563042
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "Shalimar Mannat",
     "PROJECT ADDRESS": "Faizabad road ,Barabanki",
     "BUILDER NAME": "M\/s Shalimar Corp Ltd",
     "BUILDER CONTACT PERSON NAME": "Faizal",
     "MOBILE NO. OF CONTACT PERSON": 7000258744,
     "MARKETING OFFICER NAME": "abhishek",
     "MARKETING OFFICER NO.": 9967582526
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "MI Rustle court",
     "PROJECT ADDRESS": "Gomti Nagar extension",
     "BUILDER NAME": "M\/s MI Builders",
     "BUILDER CONTACT PERSON NAME": "Habib Khan",
     "MOBILE NO. OF CONTACT PERSON": 9670217666,
     "MARKETING OFFICER NAME": "abhishek",
     "MARKETING OFFICER NO.": 9967582526
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "MI Central Park",
     "PROJECT ADDRESS": "Faizabad Road ,Lucknow",
     "BUILDER NAME": "M\/s MI Builders",
     "BUILDER CONTACT PERSON NAME": "Manoj Yadav",
     "MOBILE NO. OF CONTACT PERSON": 9984101111,
     "MARKETING OFFICER NAME": "Aunjani",
     "MARKETING OFFICER NO.": 7385796645
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "Rishita Manhattan Pahse 1",
     "PROJECT ADDRESS": "Village Sarsawan ,Sultanpur road ,sector 7 ,Gomti Nagar ,Lucknow",
     "BUILDER NAME": "M\/s Rishita Manhattan Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Jeniffer",
     "MOBILE NO. OF CONTACT PERSON": 8960066111,
     "MARKETING OFFICER NAME": "Aunjani",
     "MARKETING OFFICER NO.": 7385796645
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "Purvanchal Kings  court",
     "PROJECT ADDRESS": "GH-2 ,Vinamra Khand ,Gomti Nagar\n,Lucknow",
     "BUILDER NAME": "M\/s Purvcanchal Constructions Work pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Shamhkabir",
     "MOBILE NO. OF CONTACT PERSON": 7510000882,
     "MARKETING OFFICER NAME": "Kanchi",
     "MARKETING OFFICER NO.": 9918301293
    },
    {
     "CITY NAME": "LUCKNOW (Gomati Nagar)",
     "PROJECT NAME": "Shalimar Garden Bay(phase I)",
     "PROJECT ADDRESS": "Village Ghalia &Alinagar ,Hardoi ,Sitapur road ,Lucknow",
     "BUILDER NAME": "M\/s Shalimar KSMB Projects",
     "BUILDER CONTACT PERSON NAME": "Faizal",
     "MOBILE NO. OF CONTACT PERSON": 7000258744,
     "MARKETING OFFICER NAME": "Neha",
     "MARKETING OFFICER NO.": 7800003567
    },
    {
     "CITY NAME": "LUCKNOW",
     "PROJECT NAME": "MI CENTRAL PARK",
     "PROJECT ADDRESS": "SARSAWAN ARJUNGANJ LUCKNOW",
     "BUILDER NAME": "M.I. BUILDERS PVT LTD",
     "BUILDER CONTACT PERSON NAME": "Mr. Tariq",
     "MOBILE NO. OF CONTACT PERSON": 9670219333,
     "MARKETING OFFICER NAME": "Aunjani",
     "MARKETING OFFICER NO.": 7385796645
    },
    {
     "CITY NAME": "MEERUT",
     "PROJECT NAME": "GAUR SIDDHARTHAM",
     "PROJECT ADDRESS": "PLOT NO 08\/BS-01, SIDDHARTH VIHAR, GHAZIABAD, UTTAR PRADESH",
     "BUILDER NAME": "M\/S GAURSONS INDIA  PVT LTD",
     "BUILDER CONTACT PERSON NAME": "VINOD KUMAR PANDEY",
     "MOBILE NO. OF CONTACT PERSON": 9999319588,
     "MARKETING OFFICER NAME": "Vikas Garg -",
     "MARKETING OFFICER NO.": 9458202073
    },
    {
     "CITY NAME": "DEHRADUN",
     "PROJECT NAME": "GREEN VIEW BLOSSOM",
     "PROJECT ADDRESS": "DHORAN KHAS SAHASTRADHARA ROAD DEHRADUN",
     "BUILDER NAME": "M\/S PHOOL CHAND INFRASTRUCTURE PVT.LTD.",
     "BUILDER CONTACT PERSON NAME": "SH. RISHABH GUPTA DIRECTOR",
     "MOBILE NO. OF CONTACT PERSON": 7840050489,
     "MARKETING OFFICER NAME": "SH. ANKUR BHATT MS. NUPUR GUSAIN",
     "MARKETING OFFICER NO.": 7055005204
    },
    {
     "CITY NAME": "THANE",
     "PROJECT NAME": "SHAPOORJI PALLONJI NORTHERN LIGHTS",
     "PROJECT ADDRESS": "SUBHASH NAGAR POKHRAN ROAD NO 2 THANE",
     "BUILDER NAME": "JAYKALI DEVELOPERS PVT LTD.",
     "BUILDER CONTACT PERSON NAME": "SHREENI",
     "MOBILE NO. OF CONTACT PERSON": 9819104014,
     "MARKETING OFFICER NAME": "Swati -",
     "MARKETING OFFICER NO.": 9981278188
    },
    {
     "CITY NAME": "THANE",
     "PROJECT NAME": "GODREJ EMERALD",
     "PROJECT ADDRESS": "91\/1\/1A BHAYANDERPADA GB ROAD THANE",
     "BUILDER NAME": "M\/S GODREJ GREEN VIEW HOUSING PRIVATE LTD",
     "BUILDER CONTACT PERSON NAME": "Sales Office",
     "MOBILE NO. OF CONTACT PERSON": 9967156980,
     "MARKETING OFFICER NAME": "Dhiraj -",
     "MARKETING OFFICER NO.": 9833178201
    },
    {
     "CITY NAME": "THANE",
     "PROJECT NAME": "ANUTHAM",
     "PROJECT ADDRESS": "Property situated at CTS No 1124(pt) 90 ft Road, Opp Maratha Mandal Hall, Near Kelkar College, Mulund East Mumbai 400081",
     "BUILDER NAME": 7777074238,
     "BUILDER CONTACT PERSON NAME": "M\/S AMARDEEP CONSTRUCTIONS",
     "MOBILE NO. OF CONTACT PERSON": 7498777555,
     "MARKETING OFFICER NAME": "Dhiraj -",
     "MARKETING OFFICER NO.": 9833178201
    },
    {
     "CITY NAME": "Mumbai - Bandra",
     "PROJECT NAME": "Lodha Amara",
     "PROJECT ADDRESS": "At-Kolshet Road,Thane-400607",
     "BUILDER NAME": "M\/s Lodha developers Ltd.",
     "BUILDER CONTACT PERSON NAME": "Sales Office",
     "MOBILE NO. OF CONTACT PERSON": 2233835451,
     "MARKETING OFFICER NAME": "Mr. Ajit Pawar & Mr. Kishan Swami",
     "MARKETING OFFICER NO.": "9821954368 &\n8947033065"
    },
    {
     "CITY NAME": "Mumbai - Bandra",
     "PROJECT NAME": "Lodha Palava,",
     "PROJECT ADDRESS": "Khidkalewshwar temple, Kalyan Shil Road, Dombivali (East),Thane- 421203",
     "BUILDER NAME": "M\/s Palava Dwellers  Pvt. Ltd",
     "BUILDER CONTACT PERSON NAME": "Sales Office",
     "MOBILE NO. OF CONTACT PERSON": 2262604826,
     "MARKETING OFFICER NAME": "Nr. Mayur Sable & Mr. Sagar Kedar",
     "MARKETING OFFICER NO.": "9930491844 &\n8796451207"
    },
    {
     "CITY NAME": "Mumbai - Bandra",
     "PROJECT NAME": "Lodha Upper Thane",
     "PROJECT ADDRESS": "Surai, Mankoli Bhiwandi, Thane - 421302",
     "BUILDER NAME": "M\/s Lodha developers Ltd.",
     "BUILDER CONTACT PERSON NAME": "Sales Office",
     "MOBILE NO. OF CONTACT PERSON": 2233063421,
     "MARKETING OFFICER NAME": "Mr. Sagar Adate",
     "MARKETING OFFICER NO.": 9004824314
    },
    {
     "CITY NAME": "Mumbai - Bandra",
     "PROJECT NAME": "Monde South Titlis",
     "PROJECT ADDRESS": "Khatau Mill Compound, Next to Byculla Fire Brigade, Mumbai-400011",
     "BUILDER NAME": "M\/s.Swayam Realtors and Traders LLP",
     "BUILDER CONTACT PERSON NAME": "Sales Office",
     "MOBILE NO. OF CONTACT PERSON": 2267248500,
     "MARKETING OFFICER NAME": "Mr. Mayur Sable",
     "MARKETING OFFICER NO.": 9930491844
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "Royal Oasis",
     "PROJECT ADDRESS": "Plot no.6A\/16, jankalyan Nagar, Near BillaBong International School, Off Marve Rd, Malad (West)",
     "BUILDER NAME": "Rikki Ronie Developers",
     "BUILDER CONTACT PERSON NAME": "Manish Kumar Sharma",
     "MOBILE NO. OF CONTACT PERSON": 9324111000,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "Vardhaman Enclave",
     "PROJECT ADDRESS": "C-104, Maitree Heights T.T wadi, opp sej mall ,Marve road, Malad (west)",
     "BUILDER NAME": "Vikunj Ent. Pvt Ltd.",
     "BUILDER CONTACT PERSON NAME": "Kirit",
     "MOBILE NO. OF CONTACT PERSON": 9870336369,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "Marina Enclave",
     "PROJECT ADDRESS": "CTS No.507, S.NO.44\/1,Jankalyan Nagar, Malad, West",
     "BUILDER NAME": "Gurukrupa Builders",
     "BUILDER CONTACT PERSON NAME": "Mr. Nambiar",
     "MOBILE NO. OF CONTACT PERSON": 7506337031,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "Golden Nest Phase XVI",
     "PROJECT ADDRESS": "Shanti Niwash,1st floor, New golden nest, phaseXII,100 ft road, Bhayander east",
     "BUILDER NAME": "Sonam Builders",
     "BUILDER CONTACT PERSON NAME": "Mr. subhash",
     "MOBILE NO. OF CONTACT PERSON": 9821866360,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "Nakshatra",
     "PROJECT ADDRESS": "S.No.351,Juchandra, Near Don Bosco School, Naigaon Vasai Link Rd. Naigaon East",
     "BUILDER NAME": "JSB Group",
     "BUILDER CONTACT PERSON NAME": "Mr. Anand Seksaria",
     "MOBILE NO. OF CONTACT PERSON": 9223393035,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "The Baya Gold Spot",
     "PROJECT ADDRESS": "The Baya gold Spot, Behind Bisleri Building Andheri East Mumbai 400099",
     "BUILDER NAME": "The Renaissance",
     "BUILDER CONTACT PERSON NAME": "Mr Amit",
     "MOBILE NO. OF CONTACT PERSON": 7738057511,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "Kanakia Sevens",
     "PROJECT ADDRESS": "Kanakia Sevens,Marol, Behind Times Square, Marol, Andheri east Mumbai",
     "BUILDER NAME": "The Kanakia Spaces",
     "BUILDER CONTACT PERSON NAME": "Mr Ashish Thakare",
     "MOBILE NO. OF CONTACT PERSON": 8879610174,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "Vikunj",
     "PROJECT ADDRESS": "Marve Road Malad West, Mumbai",
     "BUILDER NAME": "NA",
     "BUILDER CONTACT PERSON NAME": "Mr. Kirit",
     "MOBILE NO. OF CONTACT PERSON": 9870336369,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "Swastik Epitom",
     "PROJECT ADDRESS": "Virar west, Vasai , Palghar",
     "BUILDER NAME": "Swatik Group",
     "BUILDER CONTACT PERSON NAME": "Pratima",
     "MOBILE NO. OF CONTACT PERSON": 7774016371,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "Joy Legends",
     "PROJECT ADDRESS": "Bandra Kurla Complex, Bandra East",
     "BUILDER NAME": "M\/S Joy Developers",
     "BUILDER CONTACT PERSON NAME": "Ketan Parekh",
     "MOBILE NO. OF CONTACT PERSON": 2267488888,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "Panom Park",
     "PROJECT ADDRESS": "off sahar Road , Vile Parle east",
     "BUILDER NAME": "Panome Developers",
     "BUILDER CONTACT PERSON NAME": "Mrs. Shivani",
     "MOBILE NO. OF CONTACT PERSON": 8422958827,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "Jessika CHS LTD",
     "PROJECT ADDRESS": "Natakwala lane, Borivali west",
     "BUILDER NAME": "Vinayak Developers",
     "BUILDER CONTACT PERSON NAME": "Mr. Yogesh Bhatt",
     "MOBILE NO. OF CONTACT PERSON": 9819161530,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "KCD Heritage",
     "PROJECT ADDRESS": "Vina Sitar Dahanukarwadi, Kandivali West",
     "BUILDER NAME": "Kavya KCD Prestine",
     "BUILDER CONTACT PERSON NAME": "Mr. Lalit Verma",
     "MOBILE NO. OF CONTACT PERSON": 9819099630,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "HM Enterprises",
     "PROJECT ADDRESS": "Plot No. 72, Opp. Ruia Schol, Mahant Road, Vile Parle(E), Mumbai 400 057",
     "BUILDER NAME": "Prabhat Urbane",
     "BUILDER CONTACT PERSON NAME": "Mr. Arun",
     "MOBILE NO. OF CONTACT PERSON": 9821157936,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Kandiwali",
     "PROJECT NAME": "Raj Universal",
     "PROJECT ADDRESS": "Dahisar(E) Check Naka , Mumbai",
     "BUILDER NAME": "Rudraksha",
     "BUILDER CONTACT PERSON NAME": "Mrs. Manjusha Khade Sales Executive",
     "MOBILE NO. OF CONTACT PERSON": 8378026164,
     "MARKETING OFFICER NAME": "Sumit",
     "MARKETING OFFICER NO.": 8860109518
    },
    {
     "CITY NAME": "Chembur",
     "PROJECT NAME": "Atlantis",
     "PROJECT ADDRESS": "A,B,C wing at powai Mumbai",
     "BUILDER NAME": "M\/s HGP Community Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Kamal Hiranandani",
     "MOBILE NO. OF CONTACT PERSON": 2262328101,
     "MARKETING OFFICER NAME": "Datta Tawale",
     "MARKETING OFFICER NO.": 9594984223
    },
    {
     "CITY NAME": "Chembur",
     "PROJECT NAME": "Maple",
     "PROJECT ADDRESS": "Powai",
     "BUILDER NAME": "Classique Assciates",
     "BUILDER CONTACT PERSON NAME": "Sameer Pradhan",
     "MOBILE NO. OF CONTACT PERSON": 9930888911,
     "MARKETING OFFICER NAME": "Datta Tawale",
     "MARKETING OFFICER NO.": 9594984224
    },
    {
     "CITY NAME": "Chembur",
     "PROJECT NAME": "Riverside, Planet, Pine",
     "PROJECT ADDRESS": "Vikhroli",
     "BUILDER NAME": "Godrej greenview HS pvt ltd",
     "BUILDER CONTACT PERSON NAME": "Norbeat Mendes",
     "MOBILE NO. OF CONTACT PERSON": 9821422860,
     "MARKETING OFFICER NAME": "Datta Tawale",
     "MARKETING OFFICER NO.": 9594984225
    },
    {
     "CITY NAME": "Chembur",
     "PROJECT NAME": "Omkar",
     "PROJECT ADDRESS": "Chembur",
     "BUILDER NAME": "Tridhatu construction pvt ltd",
     "BUILDER CONTACT PERSON NAME": "Ms. Payal",
     "MOBILE NO. OF CONTACT PERSON": "022-67083000",
     "MARKETING OFFICER NAME": "Datta Tawale",
     "MARKETING OFFICER NO.": 9594984226
    },
    {
     "CITY NAME": "AHMEDNAGAR",
     "PROJECT NAME": "COURTYARD",
     "PROJECT ADDRESS": "OPP TARAKPUR BUS STAND SAWEDI AHMEDNAGAR",
     "BUILDER NAME": "MARC DEVELOPERS",
     "BUILDER CONTACT PERSON NAME": "MR SUNIL KULKARNI",
     "MOBILE NO. OF CONTACT PERSON": 9850894148,
     "MARKETING OFFICER NAME": "Hijet Rajput",
     "MARKETING OFFICER NO.": 9730646259
    },
    {
     "CITY NAME": "AHMEDNAGAR",
     "PROJECT NAME": "AURA TOWERS",
     "PROJECT ADDRESS": "BEHIND HUNDEKARI LAWNS DNYANSAMPADA SCHOOL SAWEDI",
     "BUILDER NAME": "BANGADIWALA & BAJAJ ASSOCIATES",
     "BUILDER CONTACT PERSON NAME": "ABHIJIT PADALKAR",
     "MOBILE NO. OF CONTACT PERSON": 9373738273,
     "MARKETING OFFICER NAME": "Hijet Rajput",
     "MARKETING OFFICER NO.": 9730646259
    },
    {
     "CITY NAME": "NASHIK",
     "PROJECT NAME": "SHREE SHAKTI RESIDENCY",
     "PROJECT ADDRESS": "PLOT NO 14 KALA NAGAR JAIL ROAD",
     "BUILDER NAME": "SHIVANSH BUILD TECH",
     "BUILDER CONTACT PERSON NAME": "MR NIKHIL JAIN",
     "MOBILE NO. OF CONTACT PERSON": 9096349991,
     "MARKETING OFFICER NAME": "Chetan -",
     "MARKETING OFFICER NO.": 7768002616
    },
    {
     "CITY NAME": "NASHIK",
     "PROJECT NAME": "EMPIRE MARBAL",
     "PROJECT ADDRESS": "CHEHEDI NASHIK ROAD NASHIK 422101",
     "BUILDER NAME": "MS SHILPA ESTATE",
     "BUILDER CONTACT PERSON NAME": "MAHESH SANAP",
     "MOBILE NO. OF CONTACT PERSON": 8412910910,
     "MARKETING OFFICER NAME": "Chetan -",
     "MARKETING OFFICER NO.": 7768002616
    },
    {
     "CITY NAME": "NASHIK",
     "PROJECT NAME": "SHREE TIRUMALA GULMOHAR",
     "PROJECT ADDRESS": "MAKHAMALABAD SHIVER ROAD NASHIK",
     "BUILDER NAME": "ROONGTA HOMES LLP",
     "BUILDER CONTACT PERSON NAME": "MR YOGESH DEORE",
     "MOBILE NO. OF CONTACT PERSON": 7744949063,
     "MARKETING OFFICER NAME": "Bhushan -",
     "MARKETING OFFICER NO.": 7768002613
    },
    {
     "CITY NAME": "NAGPUR",
     "PROJECT NAME": "ADITYA LIFE SPACE",
     "PROJECT ADDRESS": "BHILGAON, TEHSIL KAMPTEE DIST NAGPUR",
     "BUILDER NAME": "GANGWANI CONSTRUCTIONS PVT LTD.",
     "BUILDER CONTACT PERSON NAME": "RAJESH AHUJA",
     "MOBILE NO. OF CONTACT PERSON": 9370186951,
     "MARKETING OFFICER NAME": "Nitin Rangari",
     "MARKETING OFFICER NO.": -8308837868
    },
    {
     "CITY NAME": "NAGPUR",
     "PROJECT NAME": "VIDAARYA APARTMENT",
     "PROJECT ADDRESS": "BORKHENDI NAGPUR",
     "BUILDER NAME": "ADITYA SHREE INFRASTRUCTURE",
     "BUILDER CONTACT PERSON NAME": "SWARNSHIL MOON",
     "MOBILE NO. OF CONTACT PERSON": 9822222807,
     "MARKETING OFFICER NAME": "Vishay Wankhede -",
     "MARKETING OFFICER NO.": 9823357776
    },
    {
     "CITY NAME": "NAGPUR",
     "PROJECT NAME": "BLUE STONE",
     "PROJECT ADDRESS": "161, 162 CHANDRAMANI NAGAR NAGPUR",
     "BUILDER NAME": "P S BUILDICON",
     "BUILDER CONTACT PERSON NAME": "SWAPNIL URKUDE",
     "MOBILE NO. OF CONTACT PERSON": 9373634163,
     "MARKETING OFFICER NAME": "Nilesh Dhurve -",
     "MARKETING OFFICER NO.": 9075010682
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Sharada Myria",
     "PROJECT ADDRESS": "DSK Vishwa Road, Dhayari",
     "BUILDER NAME": "Sharada Erectors",
     "BUILDER CONTACT PERSON NAME": "Harshada",
     "MOBILE NO. OF CONTACT PERSON": 8830968120,
     "MARKETING OFFICER NAME": "Mr.Sandeep Kumar",
     "MARKETING OFFICER NO.": 8390529660
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Oriana",
     "PROJECT ADDRESS": "Keshav Nagar, Mundhawa",
     "BUILDER NAME": "Vertical Infra",
     "BUILDER CONTACT PERSON NAME": "Sudhir Wadhwani",
     "MOBILE NO. OF CONTACT PERSON": 7507033335,
     "MARKETING OFFICER NAME": "Mr. Sangram Patil",
     "MARKETING OFFICER NO.": 9506255135
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Surabhi Iconia",
     "PROJECT ADDRESS": "Jambukarwasti Road, Naekarwadi",
     "BUILDER NAME": "Surbhi Ventures",
     "BUILDER CONTACT PERSON NAME": "Rajesh Agrawal",
     "MOBILE NO. OF CONTACT PERSON": 9822377702,
     "MARKETING OFFICER NAME": "Mr.Suhas Dhas",
     "MARKETING OFFICER NO.": 9158746222
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Shivsagar Platinum",
     "PROJECT ADDRESS": "Sun City Road, Anand Nagar",
     "BUILDER NAME": "Sable Associate",
     "BUILDER CONTACT PERSON NAME": "Vijay Pawar",
     "MOBILE NO. OF CONTACT PERSON": 9370255375,
     "MARKETING OFFICER NAME": "Mr.Rahul Waghmare",
     "MARKETING OFFICER NO.": 9850860792
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Grurkripa Heights",
     "PROJECT ADDRESS": "Old Sangvi, Bopodi",
     "BUILDER NAME": "Mount Estate Pvt. Ltd",
     "BUILDER CONTACT PERSON NAME": "Shivaji Tambe",
     "MOBILE NO. OF CONTACT PERSON": 9820700660,
     "MARKETING OFFICER NAME": "Mr.Kamlesh Varlekar",
     "MARKETING OFFICER NO.": 8898225248
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Rakshak Vatika",
     "PROJECT ADDRESS": "Talegaon",
     "BUILDER NAME": "Dreams Construction",
     "BUILDER CONTACT PERSON NAME": "Shriraj Patel",
     "MOBILE NO. OF CONTACT PERSON": 7755906012,
     "MARKETING OFFICER NAME": "Mr.Suhas Dhas",
     "MARKETING OFFICER NO.": 9158746222
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Dream Rakshak",
     "PROJECT ADDRESS": "Gadevasti Road, Wagholi",
     "BUILDER NAME": "Dream Landmark",
     "BUILDER CONTACT PERSON NAME": "VS Kisave",
     "MOBILE NO. OF CONTACT PERSON": 8421007100,
     "MARKETING OFFICER NAME": "Mr.Vishesh Agarwal",
     "MARKETING OFFICER NO.": 9518529698
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Ganesh Urban Forest",
     "PROJECT ADDRESS": "Kamshet",
     "BUILDER NAME": "Ganesh Associates",
     "BUILDER CONTACT PERSON NAME": "Vilas",
     "MOBILE NO. OF CONTACT PERSON": 916897228,
     "MARKETING OFFICER NAME": "Mr.Vishesh Agarwal",
     "MARKETING OFFICER NO.": 9518529698
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Hamy Park",
     "PROJECT ADDRESS": "Katraj",
     "BUILDER NAME": "Hamy Construction Pvt Ltd",
     "BUILDER CONTACT PERSON NAME": "Laxmikant Chaudhary",
     "MOBILE NO. OF CONTACT PERSON": 9172565501,
     "MARKETING OFFICER NAME": "Mr.Rahul Waghmare",
     "MARKETING OFFICER NO.": 9850860792
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Alcenia",
     "PROJECT ADDRESS": "Kondhwa",
     "BUILDER NAME": "Hastashilp Reality",
     "BUILDER CONTACT PERSON NAME": "Sudhir Wadhwani",
     "MOBILE NO. OF CONTACT PERSON": 7507033335,
     "MARKETING OFFICER NAME": "Mr. Sangram Patil",
     "MARKETING OFFICER NO.": 9506255135
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Prime Rose",
     "PROJECT ADDRESS": "Ambegaon",
     "BUILDER NAME": "Gurukrupa Developers",
     "BUILDER CONTACT PERSON NAME": "Dnyaneshwar Aru Anerao",
     "MOBILE NO. OF CONTACT PERSON": 9860610805,
     "MARKETING OFFICER NAME": "Mr.Kamlesh Varlekar",
     "MARKETING OFFICER NO.": 8898225248
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Ganesh Siddhi",
     "PROJECT ADDRESS": "Chikhli",
     "BUILDER NAME": "Ganesh Construction",
     "BUILDER CONTACT PERSON NAME": "Vilas",
     "MOBILE NO. OF CONTACT PERSON": 9168972288,
     "MARKETING OFFICER NAME": "Mr.Suhas Dhas",
     "MARKETING OFFICER NO.": 9158746222
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Vishal Viviana",
     "PROJECT ADDRESS": "Keshav Nagar",
     "BUILDER NAME": "Vishal Realtors",
     "BUILDER CONTACT PERSON NAME": "Sri Ram",
     "MOBILE NO. OF CONTACT PERSON": 9696967067,
     "MARKETING OFFICER NAME": "Mr. Sangram Patil",
     "MARKETING OFFICER NO.": 9506255135
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Anand Residency",
     "PROJECT ADDRESS": "Singhad Road, Ambegaon",
     "BUILDER NAME": "SR Builders",
     "BUILDER CONTACT PERSON NAME": "Mahesh",
     "MOBILE NO. OF CONTACT PERSON": 8411882477,
     "MARKETING OFFICER NAME": "Mr.Sachin Awakale",
     "MARKETING OFFICER NO.": 9637175222
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Ventaktesh Graffiti",
     "PROJECT ADDRESS": "Keshav nagar",
     "BUILDER NAME": "Venkatesh Construction",
     "BUILDER CONTACT PERSON NAME": "Amritesh Kumar Sinha",
     "MOBILE NO. OF CONTACT PERSON": 7769028844,
     "MARKETING OFFICER NAME": "Mr. Sangram Patil",
     "MARKETING OFFICER NO.": 9506255135
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Srinivas Bharatshree",
     "PROJECT ADDRESS": "Erandwane",
     "BUILDER NAME": "Darode Jog",
     "BUILDER CONTACT PERSON NAME": "Sanke Rane",
     "MOBILE NO. OF CONTACT PERSON": 8888010004,
     "MARKETING OFFICER NAME": "Mr.Kamlesh Varlekar",
     "MARKETING OFFICER NO.": 8898225248
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Utsav Homes",
     "PROJECT ADDRESS": "Bavdhan",
     "BUILDER NAME": "Prime Space Reality Group",
     "BUILDER CONTACT PERSON NAME": "Nishant",
     "MOBILE NO. OF CONTACT PERSON": 8380013280,
     "MARKETING OFFICER NAME": "Mrs.Akshata Raut",
     "MARKETING OFFICER NO.": 9309553905
    },
    {
     "CITY NAME": "Pune (Aundh)",
     "PROJECT NAME": "Indrayani Sankalp",
     "PROJECT ADDRESS": "Lohegaon",
     "BUILDER NAME": "Bebanco Developers Ltd.",
     "BUILDER CONTACT PERSON NAME": "Khan",
     "MOBILE NO. OF CONTACT PERSON": 9623771111,
     "MARKETING OFFICER NAME": "Mr.Vishesh Agarwal",
     "MARKETING OFFICER NO.": 9518529698
    },
    {
     "CITY NAME": "PATNA",
     "PROJECT NAME": "LOTUS ABODE",
     "PROJECT ADDRESS": "GOLA RAOD DANAPUR PATNA",
     "BUILDER NAME": "NUTAN CONSTRUCTION",
     "BUILDER CONTACT PERSON NAME": "SANJAY PATHAK",
     "MOBILE NO. OF CONTACT PERSON": 9334152344,
     "MARKETING OFFICER NAME": "VIBHUTI SHANKAR",
     "MARKETING OFFICER NO.": 8800138833
    },
    {
     "CITY NAME": "PATNA",
     "PROJECT NAME": "ORBITO",
     "PROJECT ADDRESS": "SAGUNA MORE DANAPUR PATNA",
     "BUILDER NAME": "MUNDESHWARI MULTICON PVT.LTD.",
     "BUILDER CONTACT PERSON NAME": "GAUTAM KUMAR",
     "MOBILE NO. OF CONTACT PERSON": 9135010051,
     "MARKETING OFFICER NAME": "VIBHUTI SHANKAR",
     "MARKETING OFFICER NO.": 8800138833
    },
    {
     "CITY NAME": "BHUBANESWAR",
     "PROJECT NAME": "ORO HEIGHTS",
     "PROJECT ADDRESS": "MOUZA:-PATRAPADA, BHUBANESWAR",
     "BUILDER NAME": "M\/S ORO INFRACON",
     "BUILDER CONTACT PERSON NAME": 9337476249,
     "MOBILE NO. OF CONTACT PERSON": "MR.SUBRAT KUMAR",
     "MARKETING OFFICER NAME": 9437262659,
     "MARKETING OFFICER NO.": 7008592553
    },
    {
     "BUILDER NAME": "PVT LTD",
     "MOBILE NO. OF CONTACT PERSON": "SAHOO"
    },
    {
     "CITY NAME": "BHUBANESWAR",
     "PROJECT NAME": "FALCON CREST",
     "PROJECT ADDRESS": "MOUZA SHYAMPUR,BHUBANESWAR,ODISHA",
     "BUILDER NAME": "M\/S FALCON REAL ESTATE PVT LTD",
     "BUILDER CONTACT PERSON NAME": "MR.PARTHAJEET PATNAIK",
     "MOBILE NO. OF CONTACT PERSON": "MR.SUBRAT KUMAR SAHOO",
     "MARKETING OFFICER NAME": 9437262659,
     "MARKETING OFFICER NO.": 7008592553
    },
    {
     "CITY NAME": "BHUBANESWAR",
     "PROJECT NAME": "SHAKTI PARADISE",
     "PROJECT ADDRESS": "MOUZA-NAHARKANTA, HANSAPAL, WARDNO-4, PS- MANCHESWAR,\nBHUBANESWAR, DIST-KHURDA, ODISHA.",
     "BUILDER NAME": "M\/S SHAKTI PROPERTIES",
     "BUILDER CONTACT PERSON NAME": "BIKRAM KUMAR SAHOO",
     "MOBILE NO. OF CONTACT PERSON": "MR.SUBRAT KUMAR SAHOO",
     "MARKETING OFFICER NAME": 9437262659,
     "MARKETING OFFICER NO.": 7008592553
    },
    {
     "CITY NAME": "RANCHI",
     "PROJECT NAME": "HARI OM NAND TOWER",
     "PROJECT ADDRESS": "KATHAL MORE, RANCHI",
     "BUILDER NAME": "M\/s Shanti Hari Realty",
     "BUILDER CONTACT PERSON NAME": "MR. UDAY SHANKAR",
     "MOBILE NO. OF CONTACT PERSON": 9199989888,
     "MARKETING OFFICER NAME": "ARVIND KUMAR-",
     "MARKETING OFFICER NO.": 9769197748
    },
    {
     "CITY NAME": "RANCHI",
     "PROJECT NAME": "EKLAVYA TOWER",
     "PROJECT ADDRESS": "EKLAVYA TOWER,PUNDAG,RELIANCE FRESH",
     "BUILDER NAME": "M\/s Eklavya Estate Pvt. Ltd.",
     "BUILDER CONTACT PERSON NAME": "Mr. Kanishk Kumar",
     "MOBILE NO. OF CONTACT PERSON": "9504252157\/9835333\n10 9\/9931795471",
     "MARKETING OFFICER NAME": "ARVIND KUMAR-",
     "MARKETING OFFICER NO.": 9769197748
    },
    {
     "CITY NAME": "RANCHI",
     "PROJECT NAME": "NABARUN",
     "PROJECT ADDRESS": "Radium Raod Ranchi, beside Maharaja Hotel",
     "BUILDER NAME": "M\/S ADHARSHILA STRUCTURE PVT. LTD",
     "BUILDER CONTACT PERSON NAME": "Dhananjay P. Raipat",
     "MOBILE NO. OF CONTACT PERSON": "9431170287\/9431170\n75 2\/9431707949",
     "MARKETING OFFICER NAME": "ARVIND KUMAR-",
     "MARKETING OFFICER NO.": 9769197748
    },
    {
     "CITY NAME": "RANCHI",
     "PROJECT NAME": "OAK FOREST",
     "PROJECT ADDRESS": "ARGORA, PUNDAG ROAD, RANCHI",
     "BUILDER NAME": "NISITH KESHARI CONSTRUCTION PVT LTD",
     "BUILDER CONTACT PERSON NAME": "MR. PANKAJ",
     "MOBILE NO. OF CONTACT PERSON": 9507035462,
     "MARKETING OFFICER NAME": "ARVIND KUMAR-",
     "MARKETING OFFICER NO.": 9769197748
    },
    {
     "CITY NAME": "RANCHI",
     "PROJECT NAME": "HARI OM NAND TOWER",
     "PROJECT ADDRESS": "KATHAL MORE, RANCHI",
     "BUILDER NAME": "M\/s Shanti Hari Realty",
     "BUILDER CONTACT PERSON NAME": "MR. UDAY SHANKAR",
     "MOBILE NO. OF CONTACT PERSON": 9199989888,
     "MARKETING OFFICER NAME": "ARVIND KUMAR-",
     "MARKETING OFFICER NO.": 9769197748
    },
    {
     "CITY NAME": "VARANASI",
     "PROJECT NAME": "Rudra Aishwaryam",
     "PROJECT ADDRESS": "Shivpur Varanasi",
     "BUILDER NAME": "M\/s RUDRA REALTECH PVT LTD",
     "BUILDER CONTACT PERSON NAME": "MAHESH SAREEN",
     "MOBILE NO. OF CONTACT PERSON": 9554950272,
     "MARKETING OFFICER NAME": "RAHUL JYOTI",
     "MARKETING OFFICER NO.": 9892857616
    },
    {
     "CITY NAME": "Varanasi",
     "PROJECT NAME": "Rudra Royal",
     "PROJECT ADDRESS": "Manduwadih varanasi",
     "BUILDER NAME": "RUDRA REALTECH PVT LTD",
     "BUILDER CONTACT PERSON NAME": "MAHESH SAREEN",
     "MOBILE NO. OF CONTACT PERSON": 9554950272,
     "MARKETING OFFICER NAME": "RAHUL JYOTI",
     "MARKETING OFFICER NO.": 9892857616
    },
    {
     "CITY NAME": "Varanasi",
     "PROJECT NAME": "RUDRA BUDDHA ENCLAVE",
     "PROJECT ADDRESS": "Sarnath varanasi",
     "BUILDER NAME": "RUDRA REAL ESTATE LTD",
     "BUILDER CONTACT PERSON NAME": "Ranjeet chadda",
     "MOBILE NO. OF CONTACT PERSON": 7607780131,
     "MARKETING OFFICER NAME": "RAHUL JYOTI",
     "MARKETING OFFICER NO.": 9892857616
    },
    {
     "CITY NAME": "Varanasi",
     "PROJECT NAME": "NAND VIRAT PARADISE",
     "PROJECT ADDRESS": "Manduwadih varanasi",
     "BUILDER NAME": "VIRAT PARADISE P LTD",
     "BUILDER CONTACT PERSON NAME": "Robin Rastogi",
     "MOBILE NO. OF CONTACT PERSON": 7617004210,
     "MARKETING OFFICER NAME": "RAHUL JYOTI",
     "MARKETING OFFICER NO.": 9892857616
    },
    {
     "CITY NAME": "Varanasi",
     "PROJECT NAME": "UMA NILAYAM",
     "PROJECT ADDRESS": "Ramnagar varanasi",
     "BUILDER NAME": "ROMA BUILDERS AND PROMOTERS PVT LTD",
     "BUILDER CONTACT PERSON NAME": "Amish Raizada",
     "MOBILE NO. OF CONTACT PERSON": 9889029512,
     "MARKETING OFFICER NAME": "RAHUL JYOTI",
     "MARKETING OFFICER NO.": 9892857616
    },
    {
     "CITY NAME": "Varanasi",
     "PROJECT NAME": "RAAGA",
     "PROJECT ADDRESS": "Shivpur varanasi",
     "BUILDER NAME": "M\/s SHAPEEARTH INFRASTRUCTURES PVT LTD",
     "BUILDER CONTACT PERSON NAME": "Ashutosh Singh",
     "MOBILE NO. OF CONTACT PERSON": 8933000021,
     "MARKETING OFFICER NAME": "RAHUL JYOTI",
     "MARKETING OFFICER NO.": 9892857616
    },
    {
     "CITY NAME": "Varanasi",
     "PROJECT NAME": "NIP GRANDWOODS",
     "PROJECT ADDRESS": "Kandwa gate dlw varanasi",
     "BUILDER NAME": "M\/S NIP HOUSING CREDIT AND DEVELOPMENT LTD",
     "BUILDER CONTACT PERSON NAME": "Shailesh Srivastava",
     "MOBILE NO. OF CONTACT PERSON": 7985078519,
     "MARKETING OFFICER NAME": "RAHUL JYOTI",
     "MARKETING OFFICER NO.": 9892857616
    }
]

export default BuilderData;